import { AddressBookIcon } from './AddressBookIcon';
import { AddressBookBoldIcon } from './AddressBookBoldIcon';
import { AirplaneIcon } from './AirplaneIcon';
import { AirplaneBoldIcon } from './AirplaneBoldIcon';
import { AlarmIcon } from './AlarmIcon';
import { AlarmBoldIcon } from './AlarmBoldIcon';
import { AndroidLogoIcon } from './AndroidLogoIcon';
import { AndroidLogoBoldIcon } from './AndroidLogoBoldIcon';
import { AppleLogoIcon } from './AppleLogoIcon';
import { AppleLogoBoldIcon } from './AppleLogoBoldIcon';
import { AppStoreLogoIcon } from './AppStoreLogoIcon';
import { AppStoreLogoBoldIcon } from './AppStoreLogoBoldIcon';
import { ArrowCircleDownIcon } from './ArrowCircleDownIcon';
import { ArrowCircleDownBoldIcon } from './ArrowCircleDownBoldIcon';
import { ArrowCircleLeftIcon } from './ArrowCircleLeftIcon';
import { ArrowCircleLeftBoldIcon } from './ArrowCircleLeftBoldIcon';
import { ArrowCircleRightIcon } from './ArrowCircleRightIcon';
import { ArrowCircleRightBoldIcon } from './ArrowCircleRightBoldIcon';
import { ArrowCircleUpIcon } from './ArrowCircleUpIcon';
import { ArrowCircleUpBoldIcon } from './ArrowCircleUpBoldIcon';
import { ArrowElbowDownRightIcon } from './ArrowElbowDownRightIcon';
import { ArrowRightIcon } from './ArrowRightIcon';
import { ArrowRightBoldIcon } from './ArrowRightBoldIcon';
import { ArrowsClockwiseIcon } from './ArrowsClockwiseIcon';
import { ArrowsClockwiseBoldIcon } from './ArrowsClockwiseBoldIcon';
import { ArrowsLeftRightIcon } from './ArrowsLeftRightIcon';
import { ArrowsLeftRightBoldIcon } from './ArrowsLeftRightBoldIcon';
import { ArrowsLeftRightFillIcon } from './ArrowsLeftRightFillIcon';
import { ArrowSquareInIcon } from './ArrowSquareInIcon';
import { ArrowSquareInBoldIcon } from './ArrowSquareInBoldIcon';
import { ArrowSquareOutIcon } from './ArrowSquareOutIcon';
import { ArrowSquareOutBoldIcon } from './ArrowSquareOutBoldIcon';
import { ArticleIcon } from './ArticleIcon';
import { ArticleBoldIcon } from './ArticleBoldIcon';
import { AtIcon } from './AtIcon';
import { AtBoldIcon } from './AtBoldIcon';
import { BabyIcon } from './BabyIcon';
import { BabyBoldIcon } from './BabyBoldIcon';
import { BackpackIcon } from './BackpackIcon';
import { BackpackBoldIcon } from './BackpackBoldIcon';
import { BagIcon } from './BagIcon';
import { BagBoldIcon } from './BagBoldIcon';
import { BalloonIcon } from './BalloonIcon';
import { BalloonBoldIcon } from './BalloonBoldIcon';
import { BandaidsIcon } from './BandaidsIcon';
import { BandaidsBoldIcon } from './BandaidsBoldIcon';
import { BankIcon } from './BankIcon';
import { BankBoldIcon } from './BankBoldIcon';
import { BarcodeIcon } from './BarcodeIcon';
import { BarcodeBoldIcon } from './BarcodeBoldIcon';
import { BellIcon } from './BellIcon';
import { BellBoldIcon } from './BellBoldIcon';
import { BellRingingIcon } from './BellRingingIcon';
import { BellRingingBoldIcon } from './BellRingingBoldIcon';
import { BellSlashIcon } from './BellSlashIcon';
import { BellSlashBoldIcon } from './BellSlashBoldIcon';
import { BinocularsIcon } from './BinocularsIcon';
import { BinocularsBoldIcon } from './BinocularsBoldIcon';
import { BookIcon } from './BookIcon';
import { BookBoldIcon } from './BookBoldIcon';
import { BookmarkIcon } from './BookmarkIcon';
import { BookmarkBoldIcon } from './BookmarkBoldIcon';
import { BookmarkFillIcon } from './BookmarkFillIcon';
import { BookmarksIcon } from './BookmarksIcon';
import { BookmarksBoldIcon } from './BookmarksBoldIcon';
import { BookOpenTextIcon } from './BookOpenTextIcon';
import { BookOpenTextBoldIcon } from './BookOpenTextBoldIcon';
import { BooksIcon } from './BooksIcon';
import { BooksBoldIcon } from './BooksBoldIcon';
import { BuildingsIcon } from './BuildingsIcon';
import { BuildingsBoldIcon } from './BuildingsBoldIcon';
import { CakeIcon } from './CakeIcon';
import { CakeBoldIcon } from './CakeBoldIcon';
import { CalculatorIcon } from './CalculatorIcon';
import { CalculatorBoldIcon } from './CalculatorBoldIcon';
import { CalendarIcon } from './CalendarIcon';
import { CalendarBoldIcon } from './CalendarBoldIcon';
import { CalendarBlankIcon } from './CalendarBlankIcon';
import { CalendarBlankBoldIcon } from './CalendarBlankBoldIcon';
import { CalendarCheckIcon } from './CalendarCheckIcon';
import { CalendarCheckBoldIcon } from './CalendarCheckBoldIcon';
import { CalendarPlusIcon } from './CalendarPlusIcon';
import { CalendarPlusBoldIcon } from './CalendarPlusBoldIcon';
import { CalendarXIcon } from './CalendarXIcon';
import { CalendarXBoldIcon } from './CalendarXBoldIcon';
import { CameraIcon } from './CameraIcon';
import { CameraBoldIcon } from './CameraBoldIcon';
import { CameraPlusIcon } from './CameraPlusIcon';
import { CameraPlusBoldIcon } from './CameraPlusBoldIcon';
import { CameraRotateIcon } from './CameraRotateIcon';
import { CameraRotateBoldIcon } from './CameraRotateBoldIcon';
import { CarIcon } from './CarIcon';
import { CarBoldIcon } from './CarBoldIcon';
import { CardholderIcon } from './CardholderIcon';
import { CardholderBoldIcon } from './CardholderBoldIcon';
import { CaretDownIcon } from './CaretDownIcon';
import { CaretDownBoldIcon } from './CaretDownBoldIcon';
import { CaretLeftIcon } from './CaretLeftIcon';
import { CaretLeftBoldIcon } from './CaretLeftBoldIcon';
import { CaretRightIcon } from './CaretRightIcon';
import { CaretRightBoldIcon } from './CaretRightBoldIcon';
import { CaretUpIcon } from './CaretUpIcon';
import { CaretUpBoldIcon } from './CaretUpBoldIcon';
import { CertificateIcon } from './CertificateIcon';
import { CertificateBoldIcon } from './CertificateBoldIcon';
import { ChartBarIcon } from './ChartBarIcon';
import { ChartBarBoldIcon } from './ChartBarBoldIcon';
import { ChartBarHorizontalIcon } from './ChartBarHorizontalIcon';
import { ChartBarHorizontalBoldIcon } from './ChartBarHorizontalBoldIcon';
import { ChartDonutIcon } from './ChartDonutIcon';
import { ChartDonutBoldIcon } from './ChartDonutBoldIcon';
import { ChartLineIcon } from './ChartLineIcon';
import { ChartLineBoldIcon } from './ChartLineBoldIcon';
import { ChartLineDownIcon } from './ChartLineDownIcon';
import { ChartLineDownBoldIcon } from './ChartLineDownBoldIcon';
import { ChartLineFillIcon } from './ChartLineFillIcon';
import { ChartLineUpIcon } from './ChartLineUpIcon';
import { ChartLineUpBoldIcon } from './ChartLineUpBoldIcon';
import { ChartPieIcon } from './ChartPieIcon';
import { ChartPieBoldIcon } from './ChartPieBoldIcon';
import { ChartPieSliceIcon } from './ChartPieSliceIcon';
import { ChartPieSliceBoldIcon } from './ChartPieSliceBoldIcon';
import { ChartScatterIcon } from './ChartScatterIcon';
import { ChartScatterBoldIcon } from './ChartScatterBoldIcon';
import { CheckIcon } from './CheckIcon';
import { CheckBoldIcon } from './CheckBoldIcon';
import { CheckCircleIcon } from './CheckCircleIcon';
import { ChecksIcon } from './ChecksIcon';
import { ChecksBoldIcon } from './ChecksBoldIcon';
import { CheckSquareIcon } from './CheckSquareIcon';
import { CheckSquareBoldIcon } from './CheckSquareBoldIcon';
import { CircleDashedIcon } from './CircleDashedIcon';
import { CircleDashedBoldIcon } from './CircleDashedBoldIcon';
import { CirclesThreePlusIcon } from './CirclesThreePlusIcon';
import { CirclesThreePlusBoldIcon } from './CirclesThreePlusBoldIcon';
import { ClockIcon } from './ClockIcon';
import { ClockBoldIcon } from './ClockBoldIcon';
import { CloudArrowUpIcon } from './CloudArrowUpIcon';
import { CloudArrowUpBoldIcon } from './CloudArrowUpBoldIcon';
import { CloudCheckIcon } from './CloudCheckIcon';
import { CloudCheckBoldIcon } from './CloudCheckBoldIcon';
import { CloudSlashIcon } from './CloudSlashIcon';
import { CloudSlashBoldIcon } from './CloudSlashBoldIcon';
import { CloudWarningIcon } from './CloudWarningIcon';
import { CloudWarningBoldIcon } from './CloudWarningBoldIcon';
import { CloudXIcon } from './CloudXIcon';
import { CloudXBoldIcon } from './CloudXBoldIcon';
import { CoffeeIcon } from './CoffeeIcon';
import { CoffeeBoldIcon } from './CoffeeBoldIcon';
import { CoinIcon } from './CoinIcon';
import { CoinBoldIcon } from './CoinBoldIcon';
import { CoinsIcon } from './CoinsIcon';
import { CoinsBoldIcon } from './CoinsBoldIcon';
import { CoinVerticalIcon } from './CoinVerticalIcon';
import { CoinVerticalBoldIcon } from './CoinVerticalBoldIcon';
import { CompassIcon } from './CompassIcon';
import { CompassBoldIcon } from './CompassBoldIcon';
import { CompassFillIcon } from './CompassFillIcon';
import { ConfettiIcon } from './ConfettiIcon';
import { ConfettiBoldIcon } from './ConfettiBoldIcon';
import { ContactlessPaymentIcon } from './ContactlessPaymentIcon';
import { ContactlessPaymentBoldIcon } from './ContactlessPaymentBoldIcon';
import { CornersOutIcon } from './CornersOutIcon';
import { CornersOutBoldIcon } from './CornersOutBoldIcon';
import { CreditCardIcon } from './CreditCardIcon';
import { CreditCardBoldIcon } from './CreditCardBoldIcon';
import { CreditCardFillIcon } from './CreditCardFillIcon';
import { CurrencyBtcIcon } from './CurrencyBtcIcon';
import { CurrencyBtcBoldIcon } from './CurrencyBtcBoldIcon';
import { CurrencyCircleDollarIcon } from './CurrencyCircleDollarIcon';
import { CurrencyCircleDollarBoldIcon } from './CurrencyCircleDollarBoldIcon';
import { CurrencyDollarIcon } from './CurrencyDollarIcon';
import { CurrencyDollarBoldIcon } from './CurrencyDollarBoldIcon';
import { CurrencyDollarSimpleIcon } from './CurrencyDollarSimpleIcon';
import { CurrencyDollarSimpleBoldIcon } from './CurrencyDollarSimpleBoldIcon';
import { CurrencyEthIcon } from './CurrencyEthIcon';
import { CurrencyEthBoldIcon } from './CurrencyEthBoldIcon';
import { CurrencyEurIcon } from './CurrencyEurIcon';
import { CurrencyEurBoldIcon } from './CurrencyEurBoldIcon';
import { CurrencyGbpIcon } from './CurrencyGbpIcon';
import { CurrencyGbpBoldIcon } from './CurrencyGbpBoldIcon';
import { CurrencyJpyIcon } from './CurrencyJpyIcon';
import { CurrencyJpyBoldIcon } from './CurrencyJpyBoldIcon';
import { DeviceMobileIcon } from './DeviceMobileIcon';
import { DeviceMobileBoldIcon } from './DeviceMobileBoldIcon';
import { DevicesIcon } from './DevicesIcon';
import { DevicesBoldIcon } from './DevicesBoldIcon';
import { DiamondIcon } from './DiamondIcon';
import { DiamondBoldIcon } from './DiamondBoldIcon';
import { DoorIcon } from './DoorIcon';
import { DoorBoldIcon } from './DoorBoldIcon';
import { DoorOpenIcon } from './DoorOpenIcon';
import { DoorOpenBoldIcon } from './DoorOpenBoldIcon';
import { DotIcon } from './DotIcon';
import { DotBoldIcon } from './DotBoldIcon';
import { DotsThreeCircleIcon } from './DotsThreeCircleIcon';
import { DotsThreeCircleBoldIcon } from './DotsThreeCircleBoldIcon';
import { DotsThreeCircleVerticalIcon } from './DotsThreeCircleVerticalIcon';
import { DotsThreeCircleVerticalBoldIcon } from './DotsThreeCircleVerticalBoldIcon';
import { DownloadSimpleIcon } from './DownloadSimpleIcon';
import { DownloadSimpleBoldIcon } from './DownloadSimpleBoldIcon';
import { EggIcon } from './EggIcon';
import { EggBoldIcon } from './EggBoldIcon';
import { EnvelopeIcon } from './EnvelopeIcon';
import { EnvelopeBoldIcon } from './EnvelopeBoldIcon';
import { ExportIcon } from './ExportIcon';
import { ExportBoldIcon } from './ExportBoldIcon';
import { EyeIcon } from './EyeIcon';
import { EyeBoldIcon } from './EyeBoldIcon';
import { EyeClosedIcon } from './EyeClosedIcon';
import { EyeClosedBoldIcon } from './EyeClosedBoldIcon';
import { EyeglassesIcon } from './EyeglassesIcon';
import { EyeglassesBoldIcon } from './EyeglassesBoldIcon';
import { EyeSlashIcon } from './EyeSlashIcon';
import { EyeSlashBoldIcon } from './EyeSlashBoldIcon';
import { FacebookLogoIcon } from './FacebookLogoIcon';
import { FacebookLogoBoldIcon } from './FacebookLogoBoldIcon';
import { FactoryIcon } from './FactoryIcon';
import { FactoryBoldIcon } from './FactoryBoldIcon';
import { FileLockIcon } from './FileLockIcon';
import { FileLockBoldIcon } from './FileLockBoldIcon';
import { FilePdfIcon } from './FilePdfIcon';
import { FilePdfBoldIcon } from './FilePdfBoldIcon';
import { FilesIcon } from './FilesIcon';
import { FilesBoldIcon } from './FilesBoldIcon';
import { FileTextIcon } from './FileTextIcon';
import { FileTextBoldIcon } from './FileTextBoldIcon';
import { FingerprintIcon } from './FingerprintIcon';
import { FingerprintBoldIcon } from './FingerprintBoldIcon';
import { FirstAidIcon } from './FirstAidIcon';
import { FirstAidBoldIcon } from './FirstAidBoldIcon';
import { FlagIcon } from './FlagIcon';
import { FlagBoldIcon } from './FlagBoldIcon';
import { FlaskIcon } from './FlaskIcon';
import { FlaskBoldIcon } from './FlaskBoldIcon';
import { GameControllerIcon } from './GameControllerIcon';
import { GameControllerBoldIcon } from './GameControllerBoldIcon';
import { GearIcon } from './GearIcon';
import { GearBoldIcon } from './GearBoldIcon';
import { GiftIcon } from './GiftIcon';
import { GiftBoldIcon } from './GiftBoldIcon';
import { GlobeIcon } from './GlobeIcon';
import { GlobeBoldIcon } from './GlobeBoldIcon';
import { GlobeHemisphereEastIcon } from './GlobeHemisphereEastIcon';
import { GlobeHemisphereEastBoldIcon } from './GlobeHemisphereEastBoldIcon';
import { GlobeHemisphereWestIcon } from './GlobeHemisphereWestIcon';
import { GlobeHemisphereWestBoldIcon } from './GlobeHemisphereWestBoldIcon';
import { GoogleChromeLogoIcon } from './GoogleChromeLogoIcon';
import { GoogleChromeLogoBoldIcon } from './GoogleChromeLogoBoldIcon';
import { GooglePlayLogoIcon } from './GooglePlayLogoIcon';
import { GooglePlayLogoBoldIcon } from './GooglePlayLogoBoldIcon';
import { GraduationCapIcon } from './GraduationCapIcon';
import { GraduationCapBoldIcon } from './GraduationCapBoldIcon';
import { HandIcon } from './HandIcon';
import { HandbagIcon } from './HandbagIcon';
import { HandbagBoldIcon } from './HandbagBoldIcon';
import { HandBoldIcon } from './HandBoldIcon';
import { HandCoinsIcon } from './HandCoinsIcon';
import { HandCoinsBoldIcon } from './HandCoinsBoldIcon';
import { HandPointingIcon } from './HandPointingIcon';
import { HandPointingBoldIcon } from './HandPointingBoldIcon';
import { HandsClappingIcon } from './HandsClappingIcon';
import { HandsClappingBoldIcon } from './HandsClappingBoldIcon';
import { HandsPrayingIcon } from './HandsPrayingIcon';
import { HandsPrayingBoldIcon } from './HandsPrayingBoldIcon';
import { HandWavingIcon } from './HandWavingIcon';
import { HandWavingBoldIcon } from './HandWavingBoldIcon';
import { HeartIcon } from './HeartIcon';
import { HeartBoldIcon } from './HeartBoldIcon';
import { HourglassIcon } from './HourglassIcon';
import { HourglassBoldIcon } from './HourglassBoldIcon';
import { HouseIcon } from './HouseIcon';
import { HouseBoldIcon } from './HouseBoldIcon';
import { HouseFillIcon } from './HouseFillIcon';
import { HouseLineIcon } from './HouseLineIcon';
import { HouseLineBoldIcon } from './HouseLineBoldIcon';
import { IdentificationCardIcon } from './IdentificationCardIcon';
import { IdentificationCardBoldIcon } from './IdentificationCardBoldIcon';
import { ImageIcon } from './ImageIcon';
import { ImageBoldIcon } from './ImageBoldIcon';
import { ImagesIcon } from './ImagesIcon';
import { ImagesBoldIcon } from './ImagesBoldIcon';
import { InfoIcon } from './InfoIcon';
import { InfoBoldIcon } from './InfoBoldIcon';
import { InstagramLogoIcon } from './InstagramLogoIcon';
import { InstagramLogoBoldIcon } from './InstagramLogoBoldIcon';
import { KeyIcon } from './KeyIcon';
import { KeyBoldIcon } from './KeyBoldIcon';
import { LightbulbIcon } from './LightbulbIcon';
import { LightbulbBoldIcon } from './LightbulbBoldIcon';
import { LightningIcon } from './LightningIcon';
import { LightningBoldIcon } from './LightningBoldIcon';
import { LightningSlashIcon } from './LightningSlashIcon';
import { LightningSlashBoldIcon } from './LightningSlashBoldIcon';
import { LinkIcon } from './LinkIcon';
import { LinkBoldIcon } from './LinkBoldIcon';
import { LinkedinLogoIcon } from './LinkedinLogoIcon';
import { LinkedinLogoBoldIcon } from './LinkedinLogoBoldIcon';
import { ListBulletsIcon } from './ListBulletsIcon';
import { ListBulletsBoldIcon } from './ListBulletsBoldIcon';
import { ListChecksIcon } from './ListChecksIcon';
import { ListChecksBoldIcon } from './ListChecksBoldIcon';
import { LockIcon } from './LockIcon';
import { LockBoldIcon } from './LockBoldIcon';
import { LockOpenIcon } from './LockOpenIcon';
import { LockOpenBoldIcon } from './LockOpenBoldIcon';
import { MagnifyingGlassIcon } from './MagnifyingGlassIcon';
import { MagnifyingGlassBoldIcon } from './MagnifyingGlassBoldIcon';
import { MapPinIcon } from './MapPinIcon';
import { MapPinBoldIcon } from './MapPinBoldIcon';
import { MapTrifoldIcon } from './MapTrifoldIcon';
import { MapTrifoldBoldIcon } from './MapTrifoldBoldIcon';
import { MessengerLogoIcon } from './MessengerLogoIcon';
import { MessengerLogoBoldIcon } from './MessengerLogoBoldIcon';
import { MoneyIcon } from './MoneyIcon';
import { MoneyBoldIcon } from './MoneyBoldIcon';
import { NotePencilIcon } from './NotePencilIcon';
import { NotePencilBoldIcon } from './NotePencilBoldIcon';
import { NotificationIcon } from './NotificationIcon';
import { NotificationBoldIcon } from './NotificationBoldIcon';
import { NumberCircleEightIcon } from './NumberCircleEightIcon';
import { NumberCircleEightBoldIcon } from './NumberCircleEightBoldIcon';
import { NumberCircleFiveIcon } from './NumberCircleFiveIcon';
import { NumberCircleFiveBoldIcon } from './NumberCircleFiveBoldIcon';
import { NumberCircleFourIcon } from './NumberCircleFourIcon';
import { NumberCircleFourBoldIcon } from './NumberCircleFourBoldIcon';
import { NumberCircleNineIcon } from './NumberCircleNineIcon';
import { NumberCircleNineBoldIcon } from './NumberCircleNineBoldIcon';
import { NumberCircleOneIcon } from './NumberCircleOneIcon';
import { NumberCircleOneBoldIcon } from './NumberCircleOneBoldIcon';
import { NumberCircleSevenIcon } from './NumberCircleSevenIcon';
import { NumberCircleSevenBoldIcon } from './NumberCircleSevenBoldIcon';
import { NumberCircleSixIcon } from './NumberCircleSixIcon';
import { NumberCircleSixBoldIcon } from './NumberCircleSixBoldIcon';
import { NumberCircleThreeIcon } from './NumberCircleThreeIcon';
import { NumberCircleThreeBoldIcon } from './NumberCircleThreeBoldIcon';
import { NumberCircleTwoIcon } from './NumberCircleTwoIcon';
import { NumberCircleTwoBoldIcon } from './NumberCircleTwoBoldIcon';
import { NumberCircleZeroIcon } from './NumberCircleZeroIcon';
import { NumberCircleZeroBoldIcon } from './NumberCircleZeroBoldIcon';
import { PaperclipIcon } from './PaperclipIcon';
import { PaperclipBoldIcon } from './PaperclipBoldIcon';
import { ParkIcon } from './ParkIcon';
import { ParkBoldIcon } from './ParkBoldIcon';
import { PasswordIcon } from './PasswordIcon';
import { PasswordBoldIcon } from './PasswordBoldIcon';
import { PawPrintIcon } from './PawPrintIcon';
import { PawPrintBoldIcon } from './PawPrintBoldIcon';
import { PaypalLogoIcon } from './PaypalLogoIcon';
import { PaypalLogoBoldIcon } from './PaypalLogoBoldIcon';
import { PencilIcon } from './PencilIcon';
import { PencilBoldIcon } from './PencilBoldIcon';
import { PencilSlashIcon } from './PencilSlashIcon';
import { PencilSlashBoldIcon } from './PencilSlashBoldIcon';
import { PercentIcon } from './PercentIcon';
import { PercentBoldIcon } from './PercentBoldIcon';
import { PhoneIcon } from './PhoneIcon';
import { PhoneBoldIcon } from './PhoneBoldIcon';
import { PhoneCallIcon } from './PhoneCallIcon';
import { PhoneCallBoldIcon } from './PhoneCallBoldIcon';
import { PhoneIncomingIcon } from './PhoneIncomingIcon';
import { PhoneIncomingBoldIcon } from './PhoneIncomingBoldIcon';
import { PiggyBankIcon } from './PiggyBankIcon';
import { PiggyBankBoldIcon } from './PiggyBankBoldIcon';
import { PillIcon } from './PillIcon';
import { PillBoldIcon } from './PillBoldIcon';
import { PlayIcon } from './PlayIcon';
import { PlayBoldIcon } from './PlayBoldIcon';
import { PlayCircleIcon } from './PlayCircleIcon';
import { PlayCircleBoldIcon } from './PlayCircleBoldIcon';
import { PlusIcon } from './PlusIcon';
import { PlusBoldIcon } from './PlusBoldIcon';
import { PlusCircleIcon } from './PlusCircleIcon';
import { PlusCircleBoldIcon } from './PlusCircleBoldIcon';
import { PrinterIcon } from './PrinterIcon';
import { PrinterBoldIcon } from './PrinterBoldIcon';
import { QuestionIcon } from './QuestionIcon';
import { QuestionBoldIcon } from './QuestionBoldIcon';
import { ReceiptIcon } from './ReceiptIcon';
import { ReceiptBoldIcon } from './ReceiptBoldIcon';
import { ReceiptXIcon } from './ReceiptXIcon';
import { ReceiptXBoldIcon } from './ReceiptXBoldIcon';
import { RedditLogoIcon } from './RedditLogoIcon';
import { RedditLogoBoldIcon } from './RedditLogoBoldIcon';
import { RoadHorizonIcon } from './RoadHorizonIcon';
import { RoadHorizonBoldIcon } from './RoadHorizonBoldIcon';
import { RocketIcon } from './RocketIcon';
import { RocketBoldIcon } from './RocketBoldIcon';
import { SealCheckIcon } from './SealCheckIcon';
import { SealCheckBoldIcon } from './SealCheckBoldIcon';
import { ShareIcon } from './ShareIcon';
import { ShareBoldIcon } from './ShareBoldIcon';
import { ShieldCheckIcon } from './ShieldCheckIcon';
import { ShieldCheckBoldIcon } from './ShieldCheckBoldIcon';
import { ShoppingCartIcon } from './ShoppingCartIcon';
import { ShoppingCartBoldIcon } from './ShoppingCartBoldIcon';
import { SignatureIcon } from './SignatureIcon';
import { SignatureBoldIcon } from './SignatureBoldIcon';
import { SlidersIcon } from './SlidersIcon';
import { SlidersBoldIcon } from './SlidersBoldIcon';
import { SlidersHorizontalIcon } from './SlidersHorizontalIcon';
import { SlidersHorizontalBoldIcon } from './SlidersHorizontalBoldIcon';
import { SortAscendingIcon } from './SortAscendingIcon';
import { SortAscendingBoldIcon } from './SortAscendingBoldIcon';
import { SortDescendingIcon } from './SortDescendingIcon';
import { SortDescendingBoldIcon } from './SortDescendingBoldIcon';
import { SpeakerHighIcon } from './SpeakerHighIcon';
import { SpeakerHighBoldIcon } from './SpeakerHighBoldIcon';
import { SpeakerSimpleSlashBoldIcon } from './SpeakerSimpleSlashBoldIcon';
import { SpeakerSlashIcon } from './SpeakerSlashIcon';
import { StarIcon } from './StarIcon';
import { StarBoldIcon } from './StarBoldIcon';
import { StrategyIcon } from './StrategyIcon';
import { StudentIcon } from './StudentIcon';
import { StudentBoldIcon } from './StudentBoldIcon';
import { SuitcaseRollingIcon } from './SuitcaseRollingIcon';
import { SuitcaseRollingBoldIcon } from './SuitcaseRollingBoldIcon';
import { SunIcon } from './SunIcon';
import { SunBoldIcon } from './SunBoldIcon';
import { TagIcon } from './TagIcon';
import { TagBoldIcon } from './TagBoldIcon';
import { TagChevronIcon } from './TagChevronIcon';
import { TagChevronBoldIcon } from './TagChevronBoldIcon';
import { TagSimpleIcon } from './TagSimpleIcon';
import { TagSimpleBoldIcon } from './TagSimpleBoldIcon';
import { TextTIcon } from './TextTIcon';
import { TextTBoldIcon } from './TextTBoldIcon';
import { TicketIcon } from './TicketIcon';
import { TicketBoldIcon } from './TicketBoldIcon';
import { ToggleLeftIcon } from './ToggleLeftIcon';
import { ToggleLeftBoldIcon } from './ToggleLeftBoldIcon';
import { ToggleRightIcon } from './ToggleRightIcon';
import { ToggleRightBoldIcon } from './ToggleRightBoldIcon';
import { ToolboxIcon } from './ToolboxIcon';
import { ToolboxBoldIcon } from './ToolboxBoldIcon';
import { TrademarkIcon } from './TrademarkIcon';
import { TrademarkBoldIcon } from './TrademarkBoldIcon';
import { TrademarkRegisteredIcon } from './TrademarkRegisteredIcon';
import { TrademarkRegisteredBoldIcon } from './TrademarkRegisteredBoldIcon';
import { TrainIcon } from './TrainIcon';
import { TrainBoldIcon } from './TrainBoldIcon';
import { TrashIcon } from './TrashIcon';
import { TrashBoldIcon } from './TrashBoldIcon';
import { TreePalmIcon } from './TreePalmIcon';
import { TreePalmBoldIcon } from './TreePalmBoldIcon';
import { TrendDownIcon } from './TrendDownIcon';
import { TrendDownBoldIcon } from './TrendDownBoldIcon';
import { TrendUpIcon } from './TrendUpIcon';
import { TrendUpBoldIcon } from './TrendUpBoldIcon';
import { TrophyIcon } from './TrophyIcon';
import { TrophyBoldIcon } from './TrophyBoldIcon';
import { TwitterLogoIcon } from './TwitterLogoIcon';
import { TwitterLogoBoldIcon } from './TwitterLogoBoldIcon';
import { UmbrellaIcon } from './UmbrellaIcon';
import { UmbrellaBoldIcon } from './UmbrellaBoldIcon';
import { UserIcon } from './UserIcon';
import { UserBoldIcon } from './UserBoldIcon';
import { UserCircleIcon } from './UserCircleIcon';
import { UserCircleBoldIcon } from './UserCircleBoldIcon';
import { UserCircleGearIcon } from './UserCircleGearIcon';
import { UserCircleGearBoldIcon } from './UserCircleGearBoldIcon';
import { UserFocusIcon } from './UserFocusIcon';
import { UserFocusBoldIcon } from './UserFocusBoldIcon';
import { UserRectangleIcon } from './UserRectangleIcon';
import { UserRectangleBoldIcon } from './UserRectangleBoldIcon';
import { UserSquareIcon } from './UserSquareIcon';
import { UserSquareBoldIcon } from './UserSquareBoldIcon';
import { VideoIcon } from './VideoIcon';
import { VideoBoldIcon } from './VideoBoldIcon';
import { WalletIcon } from './WalletIcon';
import { WalletBoldIcon } from './WalletBoldIcon';
import { WarningIcon } from './WarningIcon';
import { WarningBoldIcon } from './WarningBoldIcon';
import { WarningCircleIcon } from './WarningCircleIcon';
import { WarningCircleBoldIcon } from './WarningCircleBoldIcon';
import { WarningCircleFilledIcon } from './WarningCircleFilledIcon';
import { WarningCircleBoldFilledIcon } from './WarningCircleBoldFilledIcon';
import { WhatsappLogoIcon } from './WhatsappLogoIcon';
import { WhatsappLogoBoldIcon } from './WhatsappLogoBoldIcon';
import { WifiHighIcon } from './WifiHighIcon';
import { WifiHighBoldIcon } from './WifiHighBoldIcon';
import { WifiSlashIcon } from './WifiSlashIcon';
import { WifiSlashBoldIcon } from './WifiSlashBoldIcon';
import { XIcon } from './XIcon';
import { XBoldIcon } from './XBoldIcon';
import { XCircleIcon } from './XCircleIcon';
import { XCircleBoldIcon } from './XCircleBoldIcon';
import { YoutubeLogoIcon } from './YoutubeLogoIcon';
import { YoutubeLogoBoldIcon } from './YoutubeLogoBoldIcon';
import { ThumbsUpBoldIcon } from './ThumbsUpBoldIcon';
import { ThumbsUpIcon } from './ThumbsUpIcon';
import { TargetIcon } from './TargetIcon';
import { TargetBoldIcon } from './TargetBoldIcon';
import { SendIcon } from './SendIcon';
import { SendFilledIcon } from './SendFilledIcon';
import { RetireTreeBoldIcon } from './RetireTreeBoldIcon';
import { RetireTreeIcon } from './RetireTreeIcon';
import { SmartRocketBoldIcon } from './SmartRocketBoldIcon';
import { SmartRocketIcon } from './SmartRocketIcon';
import { TrendUpSoftBoldIcon } from './TrendUpSoftBoldIcon';
import { TrendUpSoftIcon } from './TrendUpSoftIcon';
import { ChatCircleDotsBoldIcon } from './ChatCircleDotsBoldIcon';
import { ChatCircleDotsIcon } from './ChatCircleDotsIcon';
import { LightningDashedCircleBoldIcon } from './LightningDashedCircleBoldIcon';
import { LightningDashedCircleIcon } from './LightningDashedCircleIcon';
import { SparkleIcon } from './SparkleIcon';
import { SparkleBoldIcon } from './SparkleBoldIcon';
import { ArrowUpRightIcon } from './ArrowUpRightIcon';
import { ArrowUpRightBoldIcon } from './ArrowUpRightBoldIcon';
import { ArrowDownRightIcon } from './ArrowDownRightIcon';
import { ArrowDownRightBoldIcon } from './ArrowDownRightBoldIcon';
import { MicrophoneIcon } from './MicrophoneIcon';
import { VoiceRecordIcon } from './VoiceRecordIcon';
import { VoiceRecordBoldIcon } from './VoiceRecordBoldIcon';
import { QuotationIcon } from './QuotationIcon';
import { ChatIcon } from './ChatIcon';
import { ChatBoldIcon } from './ChatBoldIcon';
import { IconTokens } from '../../../components/Icon.types';
export const iconTokensMap: IconTokens = {
	'sds-assets/base/icon/square/addressBook': { component: AddressBookIcon },
	'sds-assets/base/icon/square/addressBookBold': { component: AddressBookBoldIcon },
	'sds-assets/base/icon/square/airplane': { component: AirplaneIcon },
	'sds-assets/base/icon/square/airplaneBold': { component: AirplaneBoldIcon },
	'sds-assets/base/icon/square/alarm': { component: AlarmIcon },
	'sds-assets/base/icon/square/alarmBold': { component: AlarmBoldIcon },
	'sds-assets/base/icon/square/androidLogo': { component: AndroidLogoIcon },
	'sds-assets/base/icon/square/androidLogoBold': { component: AndroidLogoBoldIcon },
	'sds-assets/base/icon/square/appleLogo': { component: AppleLogoIcon },
	'sds-assets/base/icon/square/appleLogoBold': { component: AppleLogoBoldIcon },
	'sds-assets/base/icon/square/appStoreLogo': { component: AppStoreLogoIcon },
	'sds-assets/base/icon/square/appStoreLogoBold': { component: AppStoreLogoBoldIcon },
	'sds-assets/base/icon/square/arrowCircleDown': { component: ArrowCircleDownIcon },
	'sds-assets/base/icon/square/arrowCircleDownBold': {
		component: ArrowCircleDownBoldIcon,
	},
	'sds-assets/base/icon/square/arrowCircleLeft': { component: ArrowCircleLeftIcon },
	'sds-assets/base/icon/square/arrowCircleLeftBold': {
		component: ArrowCircleLeftBoldIcon,
	},
	'sds-assets/base/icon/square/arrowCircleRight': { component: ArrowCircleRightIcon },
	'sds-assets/base/icon/square/arrowCircleRightBold': {
		component: ArrowCircleRightBoldIcon,
	},
	'sds-assets/base/icon/square/arrowCircleUp': { component: ArrowCircleUpIcon },
	'sds-assets/base/icon/square/arrowCircleUpBold': { component: ArrowCircleUpBoldIcon },
	'sds-assets/base/icon/square/ArrowElbowDownRight': {
		component: ArrowElbowDownRightIcon,
	},
	'sds-assets/base/icon/square/arrowRight': { component: ArrowRightIcon },
	'sds-assets/base/icon/square/arrowRightBold': { component: ArrowRightBoldIcon },
	'sds-assets/base/icon/square/arrowsClockwise': { component: ArrowsClockwiseIcon },
	'sds-assets/base/icon/square/arrowsClockwiseBold': {
		component: ArrowsClockwiseBoldIcon,
	},
	'sds-assets/base/icon/square/arrowsLeftRight': { component: ArrowsLeftRightIcon },
	'sds-assets/base/icon/square/arrowsLeftRightBold': {
		component: ArrowsLeftRightBoldIcon,
	},
	'sds-assets/base/icon/square/arrowsLeftRightFill': {
		component: ArrowsLeftRightFillIcon,
	},
	'sds-assets/base/icon/square/arrowSquareIn': { component: ArrowSquareInIcon },
	'sds-assets/base/icon/square/arrowSquareInBold': { component: ArrowSquareInBoldIcon },
	'sds-assets/base/icon/square/arrowSquareOut': { component: ArrowSquareOutIcon },
	'sds-assets/base/icon/square/arrowSquareOutBold': { component: ArrowSquareOutBoldIcon },
	'sds-assets/base/icon/square/article': { component: ArticleIcon },
	'sds-assets/base/icon/square/articleBold': { component: ArticleBoldIcon },
	'sds-assets/base/icon/square/at': { component: AtIcon },
	'sds-assets/base/icon/square/atBold': { component: AtBoldIcon },
	'sds-assets/base/icon/square/baby': { component: BabyIcon },
	'sds-assets/base/icon/square/babyBold': { component: BabyBoldIcon },
	'sds-assets/base/icon/square/backpack': { component: BackpackIcon },
	'sds-assets/base/icon/square/backpackBold': { component: BackpackBoldIcon },
	'sds-assets/base/icon/square/bag': { component: BagIcon },
	'sds-assets/base/icon/square/bagBold': { component: BagBoldIcon },
	'sds-assets/base/icon/square/balloon': { component: BalloonIcon },
	'sds-assets/base/icon/square/balloonBold': { component: BalloonBoldIcon },
	'sds-assets/base/icon/square/bandaids': { component: BandaidsIcon },
	'sds-assets/base/icon/square/bandaidsBold': { component: BandaidsBoldIcon },
	'sds-assets/base/icon/square/bank': { component: BankIcon },
	'sds-assets/base/icon/square/bankBold': { component: BankBoldIcon },
	'sds-assets/base/icon/square/barcode': { component: BarcodeIcon },
	'sds-assets/base/icon/square/barcodeBold': { component: BarcodeBoldIcon },
	'sds-assets/base/icon/square/bell': { component: BellIcon },
	'sds-assets/base/icon/square/bellBold': { component: BellBoldIcon },
	'sds-assets/base/icon/square/bellRinging': { component: BellRingingIcon },
	'sds-assets/base/icon/square/bellRingingBold': { component: BellRingingBoldIcon },
	'sds-assets/base/icon/square/bellSlash': { component: BellSlashIcon },
	'sds-assets/base/icon/square/bellSlashBold': { component: BellSlashBoldIcon },
	'sds-assets/base/icon/square/binoculars': { component: BinocularsIcon },
	'sds-assets/base/icon/square/binocularsBold': { component: BinocularsBoldIcon },
	'sds-assets/base/icon/square/book': { component: BookIcon },
	'sds-assets/base/icon/square/bookBold': { component: BookBoldIcon },
	'sds-assets/base/icon/square/bookmark': { component: BookmarkIcon },
	'sds-assets/base/icon/square/bookmarkBold': { component: BookmarkBoldIcon },
	'sds-assets/base/icon/square/bookmarkFill': { component: BookmarkFillIcon },
	'sds-assets/base/icon/square/bookmarks': { component: BookmarksIcon },
	'sds-assets/base/icon/square/bookmarksBold': { component: BookmarksBoldIcon },
	'sds-assets/base/icon/square/bookOpenText': { component: BookOpenTextIcon },
	'sds-assets/base/icon/square/bookOpenTextBold': { component: BookOpenTextBoldIcon },
	'sds-assets/base/icon/square/books': { component: BooksIcon },
	'sds-assets/base/icon/square/booksBold': { component: BooksBoldIcon },
	'sds-assets/base/icon/square/buildings': { component: BuildingsIcon },
	'sds-assets/base/icon/square/buildingsBold': { component: BuildingsBoldIcon },
	'sds-assets/base/icon/square/cake': { component: CakeIcon },
	'sds-assets/base/icon/square/cakeBold': { component: CakeBoldIcon },
	'sds-assets/base/icon/square/calculator': { component: CalculatorIcon },
	'sds-assets/base/icon/square/calculatorBold': { component: CalculatorBoldIcon },
	'sds-assets/base/icon/square/calendar': { component: CalendarIcon },
	'sds-assets/base/icon/square/calendarBold': { component: CalendarBoldIcon },
	'sds-assets/base/icon/square/calendarBlank': { component: CalendarBlankIcon },
	'sds-assets/base/icon/square/calendarBlankBold': { component: CalendarBlankBoldIcon },
	'sds-assets/base/icon/square/calendarCheck': { component: CalendarCheckIcon },
	'sds-assets/base/icon/square/calendarCheckBold': { component: CalendarCheckBoldIcon },
	'sds-assets/base/icon/square/calendarPlus': { component: CalendarPlusIcon },
	'sds-assets/base/icon/square/calendarPlusBold': { component: CalendarPlusBoldIcon },
	'sds-assets/base/icon/square/calendarX': { component: CalendarXIcon },
	'sds-assets/base/icon/square/calendarXBold': { component: CalendarXBoldIcon },
	'sds-assets/base/icon/square/camera': { component: CameraIcon },
	'sds-assets/base/icon/square/cameraBold': { component: CameraBoldIcon },
	'sds-assets/base/icon/square/cameraPlus': { component: CameraPlusIcon },
	'sds-assets/base/icon/square/cameraPlusBold': { component: CameraPlusBoldIcon },
	'sds-assets/base/icon/square/cameraRotate': { component: CameraRotateIcon },
	'sds-assets/base/icon/square/cameraRotateBold': { component: CameraRotateBoldIcon },
	'sds-assets/base/icon/square/car': { component: CarIcon },
	'sds-assets/base/icon/square/carBold': { component: CarBoldIcon },
	'sds-assets/base/icon/square/cardholder': { component: CardholderIcon },
	'sds-assets/base/icon/square/cardholderBold': { component: CardholderBoldIcon },
	'sds-assets/base/icon/square/caretDown': { component: CaretDownIcon },
	'sds-assets/base/icon/square/caretDownBold': { component: CaretDownBoldIcon },
	'sds-assets/base/icon/square/caretLeft': { component: CaretLeftIcon },
	'sds-assets/base/icon/square/caretLeftBold': { component: CaretLeftBoldIcon },
	'sds-assets/base/icon/square/caretRight': { component: CaretRightIcon },
	'sds-assets/base/icon/square/caretRightBold': { component: CaretRightBoldIcon },
	'sds-assets/base/icon/square/caretUp': { component: CaretUpIcon },
	'sds-assets/base/icon/square/caretUpBold': { component: CaretUpBoldIcon },
	'sds-assets/base/icon/square/certificate': { component: CertificateIcon },
	'sds-assets/base/icon/square/certificateBold': { component: CertificateBoldIcon },
	'sds-assets/base/icon/square/chartBar': { component: ChartBarIcon },
	'sds-assets/base/icon/square/chartBarBold': { component: ChartBarBoldIcon },
	'sds-assets/base/icon/square/chartBarHorizontal': { component: ChartBarHorizontalIcon },
	'sds-assets/base/icon/square/chartBarHorizontalBold': {
		component: ChartBarHorizontalBoldIcon,
	},
	'sds-assets/base/icon/square/chartDonut': { component: ChartDonutIcon },
	'sds-assets/base/icon/square/chartDonutBold': { component: ChartDonutBoldIcon },
	'sds-assets/base/icon/square/chartLine': { component: ChartLineIcon },
	'sds-assets/base/icon/square/chartLineBold': { component: ChartLineBoldIcon },
	'sds-assets/base/icon/square/chartLineDown': { component: ChartLineDownIcon },
	'sds-assets/base/icon/square/chartLineDownBold': { component: ChartLineDownBoldIcon },
	'sds-assets/base/icon/square/chartLineFill': { component: ChartLineFillIcon },
	'sds-assets/base/icon/square/chartLineUp': { component: ChartLineUpIcon },
	'sds-assets/base/icon/square/chartLineUpBold': { component: ChartLineUpBoldIcon },
	'sds-assets/base/icon/square/chartPie': { component: ChartPieIcon },
	'sds-assets/base/icon/square/chartPieBold': { component: ChartPieBoldIcon },
	'sds-assets/base/icon/square/chartPieSlice': { component: ChartPieSliceIcon },
	'sds-assets/base/icon/square/chartPieSliceBold': { component: ChartPieSliceBoldIcon },
	'sds-assets/base/icon/square/chartScatter': { component: ChartScatterIcon },
	'sds-assets/base/icon/square/chartScatterBold': { component: ChartScatterBoldIcon },
	'sds-assets/base/icon/square/check': { component: CheckIcon },
	'sds-assets/base/icon/square/checkBold': { component: CheckBoldIcon },
	'sds-assets/base/icon/square/checkCircle': { component: CheckCircleIcon },
	'sds-assets/base/icon/square/checks': { component: ChecksIcon },
	'sds-assets/base/icon/square/checksBold': { component: ChecksBoldIcon },
	'sds-assets/base/icon/square/checkSquare': { component: CheckSquareIcon },
	'sds-assets/base/icon/square/checkSquareBold': { component: CheckSquareBoldIcon },
	'sds-assets/base/icon/square/circleDashed': { component: CircleDashedIcon },
	'sds-assets/base/icon/square/circleDashedBold': { component: CircleDashedBoldIcon },
	'sds-assets/base/icon/square/circlesThreePlus': { component: CirclesThreePlusIcon },
	'sds-assets/base/icon/square/circlesThreePlusBold': {
		component: CirclesThreePlusBoldIcon,
	},
	'sds-assets/base/icon/square/clock': { component: ClockIcon },
	'sds-assets/base/icon/square/clockBold': { component: ClockBoldIcon },
	'sds-assets/base/icon/square/cloudArrowUp': { component: CloudArrowUpIcon },
	'sds-assets/base/icon/square/cloudArrowUpBold': { component: CloudArrowUpBoldIcon },
	'sds-assets/base/icon/square/cloudCheck': { component: CloudCheckIcon },
	'sds-assets/base/icon/square/cloudCheckBold': { component: CloudCheckBoldIcon },
	'sds-assets/base/icon/square/cloudSlash': { component: CloudSlashIcon },
	'sds-assets/base/icon/square/cloudSlashBold': { component: CloudSlashBoldIcon },
	'sds-assets/base/icon/square/cloudWarning': { component: CloudWarningIcon },
	'sds-assets/base/icon/square/cloudWarningBold': { component: CloudWarningBoldIcon },
	'sds-assets/base/icon/square/cloudX': { component: CloudXIcon },
	'sds-assets/base/icon/square/cloudXBold': { component: CloudXBoldIcon },
	'sds-assets/base/icon/square/coffee': { component: CoffeeIcon },
	'sds-assets/base/icon/square/coffeeBold': { component: CoffeeBoldIcon },
	'sds-assets/base/icon/square/coin': { component: CoinIcon },
	'sds-assets/base/icon/square/coinBold': { component: CoinBoldIcon },
	'sds-assets/base/icon/square/coins': { component: CoinsIcon },
	'sds-assets/base/icon/square/coinsBold': { component: CoinsBoldIcon },
	'sds-assets/base/icon/square/coinVertical': { component: CoinVerticalIcon },
	'sds-assets/base/icon/square/coinVerticalBold': { component: CoinVerticalBoldIcon },
	'sds-assets/base/icon/square/compass': { component: CompassIcon },
	'sds-assets/base/icon/square/compassBold': { component: CompassBoldIcon },
	'sds-assets/base/icon/square/compassFill': { component: CompassFillIcon },
	'sds-assets/base/icon/square/confetti': { component: ConfettiIcon },
	'sds-assets/base/icon/square/confettiBold': { component: ConfettiBoldIcon },
	'sds-assets/base/icon/square/contactlessPayment': { component: ContactlessPaymentIcon },
	'sds-assets/base/icon/square/contactlessPaymentBold': {
		component: ContactlessPaymentBoldIcon,
	},
	'sds-assets/base/icon/square/cornersOut': { component: CornersOutIcon },
	'sds-assets/base/icon/square/cornersOutBold': { component: CornersOutBoldIcon },
	'sds-assets/base/icon/square/creditCard': { component: CreditCardIcon },
	'sds-assets/base/icon/square/creditCardBold': { component: CreditCardBoldIcon },
	'sds-assets/base/icon/square/creditCardFill': { component: CreditCardFillIcon },
	'sds-assets/base/icon/square/currencyBtc': { component: CurrencyBtcIcon },
	'sds-assets/base/icon/square/currencyBtcBold': { component: CurrencyBtcBoldIcon },
	'sds-assets/base/icon/square/currencyCircleDollar': {
		component: CurrencyCircleDollarIcon,
	},
	'sds-assets/base/icon/square/currencyCircleDollarBold': {
		component: CurrencyCircleDollarBoldIcon,
	},
	'sds-assets/base/icon/square/currencyDollar': { component: CurrencyDollarIcon },
	'sds-assets/base/icon/square/currencyDollarBold': { component: CurrencyDollarBoldIcon },
	'sds-assets/base/icon/square/currencyDollarSimple': {
		component: CurrencyDollarSimpleIcon,
	},
	'sds-assets/base/icon/square/currencyDollarSimpleBold': {
		component: CurrencyDollarSimpleBoldIcon,
	},
	'sds-assets/base/icon/square/currencyEth': { component: CurrencyEthIcon },
	'sds-assets/base/icon/square/currencyEthBold': { component: CurrencyEthBoldIcon },
	'sds-assets/base/icon/square/currencyEur': { component: CurrencyEurIcon },
	'sds-assets/base/icon/square/currencyEurBold': { component: CurrencyEurBoldIcon },
	'sds-assets/base/icon/square/currencyGbp': { component: CurrencyGbpIcon },
	'sds-assets/base/icon/square/currencyGbpBold': { component: CurrencyGbpBoldIcon },
	'sds-assets/base/icon/square/currencyJpy': { component: CurrencyJpyIcon },
	'sds-assets/base/icon/square/currencyJpyBold': { component: CurrencyJpyBoldIcon },
	'sds-assets/base/icon/square/deviceMobile': { component: DeviceMobileIcon },
	'sds-assets/base/icon/square/deviceMobileBold': { component: DeviceMobileBoldIcon },
	'sds-assets/base/icon/square/devices': { component: DevicesIcon },
	'sds-assets/base/icon/square/devicesBold': { component: DevicesBoldIcon },
	'sds-assets/base/icon/square/diamond': { component: DiamondIcon },
	'sds-assets/base/icon/square/diamondBold': { component: DiamondBoldIcon },
	'sds-assets/base/icon/square/door': { component: DoorIcon },
	'sds-assets/base/icon/square/doorBold': { component: DoorBoldIcon },
	'sds-assets/base/icon/square/doorOpen': { component: DoorOpenIcon },
	'sds-assets/base/icon/square/doorOpenBold': { component: DoorOpenBoldIcon },
	'sds-assets/base/icon/square/dot': { component: DotIcon },
	'sds-assets/base/icon/square/dotBold': { component: DotBoldIcon },
	'sds-assets/base/icon/square/dotsThreeCircle': { component: DotsThreeCircleIcon },
	'sds-assets/base/icon/square/dotsThreeCircleBold': {
		component: DotsThreeCircleBoldIcon,
	},
	'sds-assets/base/icon/square/dotsThreeCircleVertical': {
		component: DotsThreeCircleVerticalIcon,
	},
	'sds-assets/base/icon/square/dotsThreeCircleVerticalBold': {
		component: DotsThreeCircleVerticalBoldIcon,
	},
	'sds-assets/base/icon/square/downloadSimple': { component: DownloadSimpleIcon },
	'sds-assets/base/icon/square/downloadSimpleBold': { component: DownloadSimpleBoldIcon },
	'sds-assets/base/icon/square/egg': { component: EggIcon },
	'sds-assets/base/icon/square/eggBold': { component: EggBoldIcon },
	'sds-assets/base/icon/square/envelope': { component: EnvelopeIcon },
	'sds-assets/base/icon/square/envelopeBold': { component: EnvelopeBoldIcon },
	'sds-assets/base/icon/square/export': { component: ExportIcon },
	'sds-assets/base/icon/square/exportBold': { component: ExportBoldIcon },
	'sds-assets/base/icon/square/eye': { component: EyeIcon },
	'sds-assets/base/icon/square/eyeBold': { component: EyeBoldIcon },
	'sds-assets/base/icon/square/eyeClosed': { component: EyeClosedIcon },
	'sds-assets/base/icon/square/eyeClosedBold': { component: EyeClosedBoldIcon },
	'sds-assets/base/icon/square/eyeglasses': { component: EyeglassesIcon },
	'sds-assets/base/icon/square/eyeglassesBold': { component: EyeglassesBoldIcon },
	'sds-assets/base/icon/square/eyeSlash': { component: EyeSlashIcon },
	'sds-assets/base/icon/square/eyeSlashBold': { component: EyeSlashBoldIcon },
	'sds-assets/base/icon/square/facebookLogo': { component: FacebookLogoIcon },
	'sds-assets/base/icon/square/facebookLogoBold': { component: FacebookLogoBoldIcon },
	'sds-assets/base/icon/square/factory': { component: FactoryIcon },
	'sds-assets/base/icon/square/factoryBold': { component: FactoryBoldIcon },
	'sds-assets/base/icon/square/fileLock': { component: FileLockIcon },
	'sds-assets/base/icon/square/fileLockBold': { component: FileLockBoldIcon },
	'sds-assets/base/icon/square/filePdf': { component: FilePdfIcon },
	'sds-assets/base/icon/square/filePdfBold': { component: FilePdfBoldIcon },
	'sds-assets/base/icon/square/files': { component: FilesIcon },
	'sds-assets/base/icon/square/filesBold': { component: FilesBoldIcon },
	'sds-assets/base/icon/square/fileText': { component: FileTextIcon },
	'sds-assets/base/icon/square/fileTextBold': { component: FileTextBoldIcon },
	'sds-assets/base/icon/square/fingerprint': { component: FingerprintIcon },
	'sds-assets/base/icon/square/fingerprintBold': { component: FingerprintBoldIcon },
	'sds-assets/base/icon/square/firstAid': { component: FirstAidIcon },
	'sds-assets/base/icon/square/firstAidBold': { component: FirstAidBoldIcon },
	'sds-assets/base/icon/square/flag': { component: FlagIcon },
	'sds-assets/base/icon/square/flagBold': { component: FlagBoldIcon },
	'sds-assets/base/icon/square/flask': { component: FlaskIcon },
	'sds-assets/base/icon/square/flaskBold': { component: FlaskBoldIcon },
	'sds-assets/base/icon/square/gameController': { component: GameControllerIcon },
	'sds-assets/base/icon/square/gameControllerBold': { component: GameControllerBoldIcon },
	'sds-assets/base/icon/square/gear': { component: GearIcon },
	'sds-assets/base/icon/square/gearBold': { component: GearBoldIcon },
	'sds-assets/base/icon/square/gift': { component: GiftIcon },
	'sds-assets/base/icon/square/giftBold': { component: GiftBoldIcon },
	'sds-assets/base/icon/square/globe': { component: GlobeIcon },
	'sds-assets/base/icon/square/globeBold': { component: GlobeBoldIcon },
	'sds-assets/base/icon/square/globeHemisphereEast': {
		component: GlobeHemisphereEastIcon,
	},
	'sds-assets/base/icon/square/globeHemisphereEastBold': {
		component: GlobeHemisphereEastBoldIcon,
	},
	'sds-assets/base/icon/square/globeHemisphereWest': {
		component: GlobeHemisphereWestIcon,
	},
	'sds-assets/base/icon/square/globeHemisphereWestBold': {
		component: GlobeHemisphereWestBoldIcon,
	},
	'sds-assets/base/icon/square/googleChromeLogo': { component: GoogleChromeLogoIcon },
	'sds-assets/base/icon/square/googleChromeLogoBold': {
		component: GoogleChromeLogoBoldIcon,
	},
	'sds-assets/base/icon/square/googlePlayLogo': { component: GooglePlayLogoIcon },
	'sds-assets/base/icon/square/googlePlayLogoBold': { component: GooglePlayLogoBoldIcon },
	'sds-assets/base/icon/square/graduationCap': { component: GraduationCapIcon },
	'sds-assets/base/icon/square/graduationCapBold': { component: GraduationCapBoldIcon },
	'sds-assets/base/icon/square/hand': { component: HandIcon },
	'sds-assets/base/icon/square/handbag': { component: HandbagIcon },
	'sds-assets/base/icon/square/handbagBold': { component: HandbagBoldIcon },
	'sds-assets/base/icon/square/handBold': { component: HandBoldIcon },
	'sds-assets/base/icon/square/handCoins': { component: HandCoinsIcon },
	'sds-assets/base/icon/square/handCoinsBold': { component: HandCoinsBoldIcon },
	'sds-assets/base/icon/square/handPointing': { component: HandPointingIcon },
	'sds-assets/base/icon/square/handPointingBold': { component: HandPointingBoldIcon },
	'sds-assets/base/icon/square/handsClapping': { component: HandsClappingIcon },
	'sds-assets/base/icon/square/handsClappingBold': { component: HandsClappingBoldIcon },
	'sds-assets/base/icon/square/handsPraying': { component: HandsPrayingIcon },
	'sds-assets/base/icon/square/handsPrayingBold': { component: HandsPrayingBoldIcon },
	'sds-assets/base/icon/square/handWaving': { component: HandWavingIcon },
	'sds-assets/base/icon/square/handWavingBold': { component: HandWavingBoldIcon },
	'sds-assets/base/icon/square/heart': { component: HeartIcon },
	'sds-assets/base/icon/square/heartBold': { component: HeartBoldIcon },
	'sds-assets/base/icon/square/hourglass': { component: HourglassIcon },
	'sds-assets/base/icon/square/hourglassBold': { component: HourglassBoldIcon },
	'sds-assets/base/icon/square/house': { component: HouseIcon },
	'sds-assets/base/icon/square/houseBold': { component: HouseBoldIcon },
	'sds-assets/base/icon/square/houseFill': { component: HouseFillIcon },
	'sds-assets/base/icon/square/houseLine': { component: HouseLineIcon },
	'sds-assets/base/icon/square/houseLineBold': { component: HouseLineBoldIcon },
	'sds-assets/base/icon/square/identificationCard': { component: IdentificationCardIcon },
	'sds-assets/base/icon/square/identificationCardBold': {
		component: IdentificationCardBoldIcon,
	},
	'sds-assets/base/icon/square/image': { component: ImageIcon },
	'sds-assets/base/icon/square/imageBold': { component: ImageBoldIcon },
	'sds-assets/base/icon/square/images': { component: ImagesIcon },
	'sds-assets/base/icon/square/imagesBold': { component: ImagesBoldIcon },
	'sds-assets/base/icon/square/info': { component: InfoIcon },
	'sds-assets/base/icon/square/infoBold': { component: InfoBoldIcon },
	'sds-assets/base/icon/square/instagramLogo': { component: InstagramLogoIcon },
	'sds-assets/base/icon/square/instagramLogoBold': { component: InstagramLogoBoldIcon },
	'sds-assets/base/icon/square/key': { component: KeyIcon },
	'sds-assets/base/icon/square/keyBold': { component: KeyBoldIcon },
	'sds-assets/base/icon/square/lightbulb': { component: LightbulbIcon },
	'sds-assets/base/icon/square/lightbulbBold': { component: LightbulbBoldIcon },
	'sds-assets/base/icon/square/lightning': { component: LightningIcon },
	'sds-assets/base/icon/square/lightningBold': { component: LightningBoldIcon },
	'sds-assets/base/icon/square/lightningSlash': { component: LightningSlashIcon },
	'sds-assets/base/icon/square/lightningSlashBold': { component: LightningSlashBoldIcon },
	'sds-assets/base/icon/square/link': { component: LinkIcon },
	'sds-assets/base/icon/square/linkBold': { component: LinkBoldIcon },
	'sds-assets/base/icon/square/linkedinLogo': { component: LinkedinLogoIcon },
	'sds-assets/base/icon/square/linkedinLogoBold': { component: LinkedinLogoBoldIcon },
	'sds-assets/base/icon/square/listBullets': { component: ListBulletsIcon },
	'sds-assets/base/icon/square/listBulletsBold': { component: ListBulletsBoldIcon },
	'sds-assets/base/icon/square/listChecks': { component: ListChecksIcon },
	'sds-assets/base/icon/square/listChecksBold': { component: ListChecksBoldIcon },
	'sds-assets/base/icon/square/lock': { component: LockIcon },
	'sds-assets/base/icon/square/lockBold': { component: LockBoldIcon },
	'sds-assets/base/icon/square/lockOpen': { component: LockOpenIcon },
	'sds-assets/base/icon/square/lockOpenBold': { component: LockOpenBoldIcon },
	'sds-assets/base/icon/square/magnifyingGlass': { component: MagnifyingGlassIcon },
	'sds-assets/base/icon/square/magnifyingGlassBold': {
		component: MagnifyingGlassBoldIcon,
	},
	'sds-assets/base/icon/square/mapPin': { component: MapPinIcon },
	'sds-assets/base/icon/square/mapPinBold': { component: MapPinBoldIcon },
	'sds-assets/base/icon/square/mapTrifold': { component: MapTrifoldIcon },
	'sds-assets/base/icon/square/mapTrifoldBold': { component: MapTrifoldBoldIcon },
	'sds-assets/base/icon/square/messengerLogo': { component: MessengerLogoIcon },
	'sds-assets/base/icon/square/messengerLogoBold': { component: MessengerLogoBoldIcon },
	'sds-assets/base/icon/square/money': { component: MoneyIcon },
	'sds-assets/base/icon/square/moneyBold': { component: MoneyBoldIcon },
	'sds-assets/base/icon/square/notePencil': { component: NotePencilIcon },
	'sds-assets/base/icon/square/notePencilBold': { component: NotePencilBoldIcon },
	'sds-assets/base/icon/square/notification': { component: NotificationIcon },
	'sds-assets/base/icon/square/notificationBold': { component: NotificationBoldIcon },
	'sds-assets/base/icon/square/numberCircleEight': { component: NumberCircleEightIcon },
	'sds-assets/base/icon/square/numberCircleEightBold': {
		component: NumberCircleEightBoldIcon,
	},
	'sds-assets/base/icon/square/numberCircleFive': { component: NumberCircleFiveIcon },
	'sds-assets/base/icon/square/numberCircleFiveBold': {
		component: NumberCircleFiveBoldIcon,
	},
	'sds-assets/base/icon/square/numberCircleFour': { component: NumberCircleFourIcon },
	'sds-assets/base/icon/square/numberCircleFourBold': {
		component: NumberCircleFourBoldIcon,
	},
	'sds-assets/base/icon/square/numberCircleNine': { component: NumberCircleNineIcon },
	'sds-assets/base/icon/square/numberCircleNineBold': {
		component: NumberCircleNineBoldIcon,
	},
	'sds-assets/base/icon/square/numberCircleOne': { component: NumberCircleOneIcon },
	'sds-assets/base/icon/square/numberCircleOneBold': {
		component: NumberCircleOneBoldIcon,
	},
	'sds-assets/base/icon/square/numberCircleSeven': { component: NumberCircleSevenIcon },
	'sds-assets/base/icon/square/numberCircleSevenBold': {
		component: NumberCircleSevenBoldIcon,
	},
	'sds-assets/base/icon/square/numberCircleSix': { component: NumberCircleSixIcon },
	'sds-assets/base/icon/square/numberCircleSixBold': {
		component: NumberCircleSixBoldIcon,
	},
	'sds-assets/base/icon/square/numberCircleThree': { component: NumberCircleThreeIcon },
	'sds-assets/base/icon/square/numberCircleThreeBold': {
		component: NumberCircleThreeBoldIcon,
	},
	'sds-assets/base/icon/square/numberCircleTwo': { component: NumberCircleTwoIcon },
	'sds-assets/base/icon/square/numberCircleTwoBold': {
		component: NumberCircleTwoBoldIcon,
	},
	'sds-assets/base/icon/square/numberCircleZero': { component: NumberCircleZeroIcon },
	'sds-assets/base/icon/square/numberCircleZeroBold': {
		component: NumberCircleZeroBoldIcon,
	},
	'sds-assets/base/icon/square/paperclip': { component: PaperclipIcon },
	'sds-assets/base/icon/square/paperclipBold': { component: PaperclipBoldIcon },
	'sds-assets/base/icon/square/park': { component: ParkIcon },
	'sds-assets/base/icon/square/parkBold': { component: ParkBoldIcon },
	'sds-assets/base/icon/square/password': { component: PasswordIcon },
	'sds-assets/base/icon/square/passwordBold': { component: PasswordBoldIcon },
	'sds-assets/base/icon/square/pawPrint': { component: PawPrintIcon },
	'sds-assets/base/icon/square/pawPrintBold': { component: PawPrintBoldIcon },
	'sds-assets/base/icon/square/paypalLogo': { component: PaypalLogoIcon },
	'sds-assets/base/icon/square/paypalLogoBold': { component: PaypalLogoBoldIcon },
	'sds-assets/base/icon/square/pencil': { component: PencilIcon },
	'sds-assets/base/icon/square/pencilBold': { component: PencilBoldIcon },
	'sds-assets/base/icon/square/pencilSlash': { component: PencilSlashIcon },
	'sds-assets/base/icon/square/pencilSlashBold': { component: PencilSlashBoldIcon },
	'sds-assets/base/icon/square/percent': { component: PercentIcon },
	'sds-assets/base/icon/square/percentBold': { component: PercentBoldIcon },
	'sds-assets/base/icon/square/phone': { component: PhoneIcon },
	'sds-assets/base/icon/square/phoneBold': { component: PhoneBoldIcon },
	'sds-assets/base/icon/square/phoneCall': { component: PhoneCallIcon },
	'sds-assets/base/icon/square/phoneCallBold': { component: PhoneCallBoldIcon },
	'sds-assets/base/icon/square/phoneIncoming': { component: PhoneIncomingIcon },
	'sds-assets/base/icon/square/phoneIncomingBold': { component: PhoneIncomingBoldIcon },
	'sds-assets/base/icon/square/piggyBank': { component: PiggyBankIcon },
	'sds-assets/base/icon/square/piggyBankBold': { component: PiggyBankBoldIcon },
	'sds-assets/base/icon/square/pill': { component: PillIcon },
	'sds-assets/base/icon/square/pillBold': { component: PillBoldIcon },
	'sds-assets/base/icon/square/play': { component: PlayIcon },
	'sds-assets/base/icon/square/playBold': { component: PlayBoldIcon },
	'sds-assets/base/icon/square/playCircle': { component: PlayCircleIcon },
	'sds-assets/base/icon/square/playCircleBold': { component: PlayCircleBoldIcon },
	'sds-assets/base/icon/square/plus': { component: PlusIcon },
	'sds-assets/base/icon/square/plusBold': { component: PlusBoldIcon },
	'sds-assets/base/icon/square/plusCircle': { component: PlusCircleIcon },
	'sds-assets/base/icon/square/plusCircleBold': { component: PlusCircleBoldIcon },
	'sds-assets/base/icon/square/printer': { component: PrinterIcon },
	'sds-assets/base/icon/square/printerBold': { component: PrinterBoldIcon },
	'sds-assets/base/icon/square/question': { component: QuestionIcon },
	'sds-assets/base/icon/square/questionBold': { component: QuestionBoldIcon },
	'sds-assets/base/icon/square/receipt': { component: ReceiptIcon },
	'sds-assets/base/icon/square/receiptBold': { component: ReceiptBoldIcon },
	'sds-assets/base/icon/square/receiptX': { component: ReceiptXIcon },
	'sds-assets/base/icon/square/receiptXBold': { component: ReceiptXBoldIcon },
	'sds-assets/base/icon/square/redditLogo': { component: RedditLogoIcon },
	'sds-assets/base/icon/square/redditLogoBold': { component: RedditLogoBoldIcon },
	'sds-assets/base/icon/square/roadHorizon': { component: RoadHorizonIcon },
	'sds-assets/base/icon/square/roadHorizonBold': { component: RoadHorizonBoldIcon },
	'sds-assets/base/icon/square/rocket': { component: RocketIcon },
	'sds-assets/base/icon/square/rocketBold': { component: RocketBoldIcon },
	'sds-assets/base/icon/square/sealCheck': { component: SealCheckIcon },
	'sds-assets/base/icon/square/sealCheckBold': { component: SealCheckBoldIcon },
	'sds-assets/base/icon/square/share': { component: ShareIcon },
	'sds-assets/base/icon/square/shareBold': { component: ShareBoldIcon },
	'sds-assets/base/icon/square/shieldCheck': { component: ShieldCheckIcon },
	'sds-assets/base/icon/square/shieldCheckBold': { component: ShieldCheckBoldIcon },
	'sds-assets/base/icon/square/shoppingCart': { component: ShoppingCartIcon },
	'sds-assets/base/icon/square/shoppingCartBold': { component: ShoppingCartBoldIcon },
	'sds-assets/base/icon/square/signature': { component: SignatureIcon },
	'sds-assets/base/icon/square/signatureBold': { component: SignatureBoldIcon },
	'sds-assets/base/icon/square/sliders': { component: SlidersIcon },
	'sds-assets/base/icon/square/slidersBold': { component: SlidersBoldIcon },
	'sds-assets/base/icon/square/slidersHorizontal': { component: SlidersHorizontalIcon },
	'sds-assets/base/icon/square/slidersHorizontalBold': {
		component: SlidersHorizontalBoldIcon,
	},
	'sds-assets/base/icon/square/sortAscending': { component: SortAscendingIcon },
	'sds-assets/base/icon/square/sortAscendingBold': { component: SortAscendingBoldIcon },
	'sds-assets/base/icon/square/sortDescending': { component: SortDescendingIcon },
	'sds-assets/base/icon/square/sortDescendingBold': { component: SortDescendingBoldIcon },
	'sds-assets/base/icon/square/speakerHigh': { component: SpeakerHighIcon },
	'sds-assets/base/icon/square/speakerHighBold': { component: SpeakerHighBoldIcon },
	'sds-assets/base/icon/square/speakerSimpleSlashBold': {
		component: SpeakerSimpleSlashBoldIcon,
	},
	'sds-assets/base/icon/square/speakerSlash': { component: SpeakerSlashIcon },
	'sds-assets/base/icon/square/star': { component: StarIcon },
	'sds-assets/base/icon/square/starBold': { component: StarBoldIcon },
	'sds-assets/base/icon/square/strategy': { component: StrategyIcon },
	'sds-assets/base/icon/square/student': { component: StudentIcon },
	'sds-assets/base/icon/square/studentBold': { component: StudentBoldIcon },
	'sds-assets/base/icon/square/suitcaseRolling': { component: SuitcaseRollingIcon },
	'sds-assets/base/icon/square/suitcaseRollingBold': {
		component: SuitcaseRollingBoldIcon,
	},
	'sds-assets/base/icon/square/sun': { component: SunIcon },
	'sds-assets/base/icon/square/sunBold': { component: SunBoldIcon },
	'sds-assets/base/icon/square/tag': { component: TagIcon },
	'sds-assets/base/icon/square/tagBold': { component: TagBoldIcon },
	'sds-assets/base/icon/square/tagChevron': { component: TagChevronIcon },
	'sds-assets/base/icon/square/tagChevronBold': { component: TagChevronBoldIcon },
	'sds-assets/base/icon/square/tagSimple': { component: TagSimpleIcon },
	'sds-assets/base/icon/square/tagSimpleBold': { component: TagSimpleBoldIcon },
	'sds-assets/base/icon/square/textT': { component: TextTIcon },
	'sds-assets/base/icon/square/textTBold': { component: TextTBoldIcon },
	'sds-assets/base/icon/square/ticket': { component: TicketIcon },
	'sds-assets/base/icon/square/ticketBold': { component: TicketBoldIcon },
	'sds-assets/base/icon/square/toggleLeft': { component: ToggleLeftIcon },
	'sds-assets/base/icon/square/toggleLeftBold': { component: ToggleLeftBoldIcon },
	'sds-assets/base/icon/square/toggleRight': { component: ToggleRightIcon },
	'sds-assets/base/icon/square/toggleRightBold': { component: ToggleRightBoldIcon },
	'sds-assets/base/icon/square/toolbox': { component: ToolboxIcon },
	'sds-assets/base/icon/square/toolboxBold': { component: ToolboxBoldIcon },
	'sds-assets/base/icon/square/trademark': { component: TrademarkIcon },
	'sds-assets/base/icon/square/trademarkBold': { component: TrademarkBoldIcon },
	'sds-assets/base/icon/square/trademarkRegistered': {
		component: TrademarkRegisteredIcon,
	},
	'sds-assets/base/icon/square/trademarkRegisteredBold': {
		component: TrademarkRegisteredBoldIcon,
	},
	'sds-assets/base/icon/square/train': { component: TrainIcon },
	'sds-assets/base/icon/square/trainBold': { component: TrainBoldIcon },
	'sds-assets/base/icon/square/trash': { component: TrashIcon },
	'sds-assets/base/icon/square/trashBold': { component: TrashBoldIcon },
	'sds-assets/base/icon/square/treePalm': { component: TreePalmIcon },
	'sds-assets/base/icon/square/treePalmBold': { component: TreePalmBoldIcon },
	'sds-assets/base/icon/square/trendDown': { component: TrendDownIcon },
	'sds-assets/base/icon/square/trendDownBold': { component: TrendDownBoldIcon },
	'sds-assets/base/icon/square/trendUp': { component: TrendUpIcon },
	'sds-assets/base/icon/square/trendUpBold': { component: TrendUpBoldIcon },
	'sds-assets/base/icon/square/trophy': { component: TrophyIcon },
	'sds-assets/base/icon/square/trophyBold': { component: TrophyBoldIcon },
	'sds-assets/base/icon/square/twitterLogo': { component: TwitterLogoIcon },
	'sds-assets/base/icon/square/twitterLogoBold': { component: TwitterLogoBoldIcon },
	'sds-assets/base/icon/square/umbrella': { component: UmbrellaIcon },
	'sds-assets/base/icon/square/umbrellaBold': { component: UmbrellaBoldIcon },
	'sds-assets/base/icon/square/user': { component: UserIcon },
	'sds-assets/base/icon/square/userBold': { component: UserBoldIcon },
	'sds-assets/base/icon/square/userCircle': { component: UserCircleIcon },
	'sds-assets/base/icon/square/userCircleBold': { component: UserCircleBoldIcon },
	'sds-assets/base/icon/square/userCircleGear': { component: UserCircleGearIcon },
	'sds-assets/base/icon/square/userCircleGearBold': { component: UserCircleGearBoldIcon },
	'sds-assets/base/icon/square/userFocus': { component: UserFocusIcon },
	'sds-assets/base/icon/square/userFocusBold': { component: UserFocusBoldIcon },
	'sds-assets/base/icon/square/userRectangle': { component: UserRectangleIcon },
	'sds-assets/base/icon/square/userRectangleBold': { component: UserRectangleBoldIcon },
	'sds-assets/base/icon/square/userSquare': { component: UserSquareIcon },
	'sds-assets/base/icon/square/userSquareBold': { component: UserSquareBoldIcon },
	'sds-assets/base/icon/square/video': { component: VideoIcon },
	'sds-assets/base/icon/square/videoBold': { component: VideoBoldIcon },
	'sds-assets/base/icon/square/wallet': { component: WalletIcon },
	'sds-assets/base/icon/square/walletBold': { component: WalletBoldIcon },
	'sds-assets/base/icon/square/warning': { component: WarningIcon },
	'sds-assets/base/icon/square/warningBold': { component: WarningBoldIcon },
	'sds-assets/base/icon/square/warningCircle': { component: WarningCircleIcon },
	'sds-assets/base/icon/square/warningCircleBold': { component: WarningCircleBoldIcon },
	'sds-assets/base/icon/square/warningCircleFilled': {
		component: WarningCircleFilledIcon,
	},
	'sds-assets/base/icon/square/warningCircleBoldFilled': {
		component: WarningCircleBoldFilledIcon,
	},
	'sds-assets/base/icon/square/whatsappLogo': { component: WhatsappLogoIcon },
	'sds-assets/base/icon/square/whatsappLogoBold': { component: WhatsappLogoBoldIcon },
	'sds-assets/base/icon/square/wifiHigh': { component: WifiHighIcon },
	'sds-assets/base/icon/square/wifiHighBold': { component: WifiHighBoldIcon },
	'sds-assets/base/icon/square/wifiSlash': { component: WifiSlashIcon },
	'sds-assets/base/icon/square/wifiSlashBold': { component: WifiSlashBoldIcon },
	'sds-assets/base/icon/square/x': { component: XIcon },
	'sds-assets/base/icon/square/xBold': { component: XBoldIcon },
	'sds-assets/base/icon/square/xCircle': { component: XCircleIcon },
	'sds-assets/base/icon/square/xCircleBold': { component: XCircleBoldIcon },
	'sds-assets/base/icon/square/youtubeLogo': { component: YoutubeLogoIcon },
	'sds-assets/base/icon/square/youtubeLogoBold': { component: YoutubeLogoBoldIcon },
	'sds-assets/base/icon/square/thumbsUpBold': { component: ThumbsUpBoldIcon },
	'sds-assets/base/icon/square/thumbsUp': { component: ThumbsUpIcon },
	'sds-assets/base/icon/square/target': { component: TargetIcon },
	'sds-assets/base/icon/square/targetBold': { component: TargetBoldIcon },
	'sds-assets/base/icon/square/send': { component: SendIcon },
	'sds-assets/base/icon/square/sendFilled': { component: SendFilledIcon },
	'sds-assets/base/icon/square/retireTreeBold': { component: RetireTreeBoldIcon },
	'sds-assets/base/icon/square/retireTree': { component: RetireTreeIcon },
	'sds-assets/base/icon/square/smartRocketBold': { component: SmartRocketBoldIcon },
	'sds-assets/base/icon/square/smartRocket': { component: SmartRocketIcon },
	'sds-assets/base/icon/square/trendUpSoftBold': { component: TrendUpSoftBoldIcon },
	'sds-assets/base/icon/square/trendUpSoft': { component: TrendUpSoftIcon },
	'sds-assets/base/icon/square/chatCircleDotsBold': { component: ChatCircleDotsBoldIcon },
	'sds-assets/base/icon/square/chatCircleDots': { component: ChatCircleDotsIcon },
	'sds-assets/base/icon/square/lightningDashedCircleBold': {
		component: LightningDashedCircleBoldIcon,
	},
	'sds-assets/base/icon/square/lightningDashedCircle': {
		component: LightningDashedCircleIcon,
	},
	'sds-assets/base/icon/square/sparkle': { component: SparkleIcon },
	'sds-assets/base/icon/square/sparkleBold': { component: SparkleBoldIcon },
	'sds-assets/base/icon/square/arrowUpRight': { component: ArrowUpRightIcon },
	'sds-assets/base/icon/square/arrowUpRightBold': { component: ArrowUpRightBoldIcon },
	'sds-assets/base/icon/square/arrowDownRight': { component: ArrowDownRightIcon },
	'sds-assets/base/icon/square/arrowDownRightBold': { component: ArrowDownRightBoldIcon },
	'sds-assets/base/icon/square/microphone': { component: MicrophoneIcon },
	'sds-assets/base/icon/square/voiceRecord': { component: VoiceRecordIcon },
	'sds-assets/base/icon/square/voiceRecordBold': { component: VoiceRecordBoldIcon },
	'sds-assets/base/icon/square/quotation': { component: QuotationIcon },
	'sds-assets/base/icon/square/chat': { component: ChatIcon },
	'sds-assets/base/icon/square/chatBold': { component: ChatBoldIcon },
};
export { AddressBookIcon } from './AddressBookIcon';
export { AddressBookBoldIcon } from './AddressBookBoldIcon';
export { AirplaneIcon } from './AirplaneIcon';
export { AirplaneBoldIcon } from './AirplaneBoldIcon';
export { AlarmIcon } from './AlarmIcon';
export { AlarmBoldIcon } from './AlarmBoldIcon';
export { AndroidLogoIcon } from './AndroidLogoIcon';
export { AndroidLogoBoldIcon } from './AndroidLogoBoldIcon';
export { AppleLogoIcon } from './AppleLogoIcon';
export { AppleLogoBoldIcon } from './AppleLogoBoldIcon';
export { AppStoreLogoIcon } from './AppStoreLogoIcon';
export { AppStoreLogoBoldIcon } from './AppStoreLogoBoldIcon';
export { ArrowCircleDownIcon } from './ArrowCircleDownIcon';
export { ArrowCircleDownBoldIcon } from './ArrowCircleDownBoldIcon';
export { ArrowCircleLeftIcon } from './ArrowCircleLeftIcon';
export { ArrowCircleLeftBoldIcon } from './ArrowCircleLeftBoldIcon';
export { ArrowCircleRightIcon } from './ArrowCircleRightIcon';
export { ArrowCircleRightBoldIcon } from './ArrowCircleRightBoldIcon';
export { ArrowCircleUpIcon } from './ArrowCircleUpIcon';
export { ArrowCircleUpBoldIcon } from './ArrowCircleUpBoldIcon';
export { ArrowElbowDownRightIcon } from './ArrowElbowDownRightIcon';
export { ArrowRightIcon } from './ArrowRightIcon';
export { ArrowRightBoldIcon } from './ArrowRightBoldIcon';
export { ArrowsClockwiseIcon } from './ArrowsClockwiseIcon';
export { ArrowsClockwiseBoldIcon } from './ArrowsClockwiseBoldIcon';
export { ArrowsLeftRightIcon } from './ArrowsLeftRightIcon';
export { ArrowsLeftRightBoldIcon } from './ArrowsLeftRightBoldIcon';
export { ArrowsLeftRightFillIcon } from './ArrowsLeftRightFillIcon';
export { ArrowSquareInIcon } from './ArrowSquareInIcon';
export { ArrowSquareInBoldIcon } from './ArrowSquareInBoldIcon';
export { ArrowSquareOutIcon } from './ArrowSquareOutIcon';
export { ArrowSquareOutBoldIcon } from './ArrowSquareOutBoldIcon';
export { ArticleIcon } from './ArticleIcon';
export { ArticleBoldIcon } from './ArticleBoldIcon';
export { AtIcon } from './AtIcon';
export { AtBoldIcon } from './AtBoldIcon';
export { BabyIcon } from './BabyIcon';
export { BabyBoldIcon } from './BabyBoldIcon';
export { BackpackIcon } from './BackpackIcon';
export { BackpackBoldIcon } from './BackpackBoldIcon';
export { BagIcon } from './BagIcon';
export { BagBoldIcon } from './BagBoldIcon';
export { BalloonIcon } from './BalloonIcon';
export { BalloonBoldIcon } from './BalloonBoldIcon';
export { BandaidsIcon } from './BandaidsIcon';
export { BandaidsBoldIcon } from './BandaidsBoldIcon';
export { BankIcon } from './BankIcon';
export { BankBoldIcon } from './BankBoldIcon';
export { BarcodeIcon } from './BarcodeIcon';
export { BarcodeBoldIcon } from './BarcodeBoldIcon';
export { BellIcon } from './BellIcon';
export { BellBoldIcon } from './BellBoldIcon';
export { BellRingingIcon } from './BellRingingIcon';
export { BellRingingBoldIcon } from './BellRingingBoldIcon';
export { BellSlashIcon } from './BellSlashIcon';
export { BellSlashBoldIcon } from './BellSlashBoldIcon';
export { BinocularsIcon } from './BinocularsIcon';
export { BinocularsBoldIcon } from './BinocularsBoldIcon';
export { BookIcon } from './BookIcon';
export { BookBoldIcon } from './BookBoldIcon';
export { BookmarkIcon } from './BookmarkIcon';
export { BookmarkBoldIcon } from './BookmarkBoldIcon';
export { BookmarkFillIcon } from './BookmarkFillIcon';
export { BookmarksIcon } from './BookmarksIcon';
export { BookmarksBoldIcon } from './BookmarksBoldIcon';
export { BookOpenTextIcon } from './BookOpenTextIcon';
export { BookOpenTextBoldIcon } from './BookOpenTextBoldIcon';
export { BooksIcon } from './BooksIcon';
export { BooksBoldIcon } from './BooksBoldIcon';
export { BuildingsIcon } from './BuildingsIcon';
export { BuildingsBoldIcon } from './BuildingsBoldIcon';
export { CakeIcon } from './CakeIcon';
export { CakeBoldIcon } from './CakeBoldIcon';
export { CalculatorIcon } from './CalculatorIcon';
export { CalculatorBoldIcon } from './CalculatorBoldIcon';
export { CalendarIcon } from './CalendarIcon';
export { CalendarBoldIcon } from './CalendarBoldIcon';
export { CalendarBlankIcon } from './CalendarBlankIcon';
export { CalendarBlankBoldIcon } from './CalendarBlankBoldIcon';
export { CalendarCheckIcon } from './CalendarCheckIcon';
export { CalendarCheckBoldIcon } from './CalendarCheckBoldIcon';
export { CalendarPlusIcon } from './CalendarPlusIcon';
export { CalendarPlusBoldIcon } from './CalendarPlusBoldIcon';
export { CalendarXIcon } from './CalendarXIcon';
export { CalendarXBoldIcon } from './CalendarXBoldIcon';
export { CameraIcon } from './CameraIcon';
export { CameraBoldIcon } from './CameraBoldIcon';
export { CameraPlusIcon } from './CameraPlusIcon';
export { CameraPlusBoldIcon } from './CameraPlusBoldIcon';
export { CameraRotateIcon } from './CameraRotateIcon';
export { CameraRotateBoldIcon } from './CameraRotateBoldIcon';
export { CarIcon } from './CarIcon';
export { CarBoldIcon } from './CarBoldIcon';
export { CardholderIcon } from './CardholderIcon';
export { CardholderBoldIcon } from './CardholderBoldIcon';
export { CaretDownIcon } from './CaretDownIcon';
export { CaretDownBoldIcon } from './CaretDownBoldIcon';
export { CaretLeftIcon } from './CaretLeftIcon';
export { CaretLeftBoldIcon } from './CaretLeftBoldIcon';
export { CaretRightIcon } from './CaretRightIcon';
export { CaretRightBoldIcon } from './CaretRightBoldIcon';
export { CaretUpIcon } from './CaretUpIcon';
export { CaretUpBoldIcon } from './CaretUpBoldIcon';
export { CertificateIcon } from './CertificateIcon';
export { CertificateBoldIcon } from './CertificateBoldIcon';
export { ChartBarIcon } from './ChartBarIcon';
export { ChartBarBoldIcon } from './ChartBarBoldIcon';
export { ChartBarHorizontalIcon } from './ChartBarHorizontalIcon';
export { ChartBarHorizontalBoldIcon } from './ChartBarHorizontalBoldIcon';
export { ChartDonutIcon } from './ChartDonutIcon';
export { ChartDonutBoldIcon } from './ChartDonutBoldIcon';
export { ChartLineIcon } from './ChartLineIcon';
export { ChartLineBoldIcon } from './ChartLineBoldIcon';
export { ChartLineDownIcon } from './ChartLineDownIcon';
export { ChartLineDownBoldIcon } from './ChartLineDownBoldIcon';
export { ChartLineFillIcon } from './ChartLineFillIcon';
export { ChartLineUpIcon } from './ChartLineUpIcon';
export { ChartLineUpBoldIcon } from './ChartLineUpBoldIcon';
export { ChartPieIcon } from './ChartPieIcon';
export { ChartPieBoldIcon } from './ChartPieBoldIcon';
export { ChartPieSliceIcon } from './ChartPieSliceIcon';
export { ChartPieSliceBoldIcon } from './ChartPieSliceBoldIcon';
export { ChartScatterIcon } from './ChartScatterIcon';
export { ChartScatterBoldIcon } from './ChartScatterBoldIcon';
export { CheckIcon } from './CheckIcon';
export { CheckBoldIcon } from './CheckBoldIcon';
export { CheckCircleIcon } from './CheckCircleIcon';
export { ChecksIcon } from './ChecksIcon';
export { ChecksBoldIcon } from './ChecksBoldIcon';
export { CheckSquareIcon } from './CheckSquareIcon';
export { CheckSquareBoldIcon } from './CheckSquareBoldIcon';
export { CircleDashedIcon } from './CircleDashedIcon';
export { CircleDashedBoldIcon } from './CircleDashedBoldIcon';
export { CirclesThreePlusIcon } from './CirclesThreePlusIcon';
export { CirclesThreePlusBoldIcon } from './CirclesThreePlusBoldIcon';
export { ClockIcon } from './ClockIcon';
export { ClockBoldIcon } from './ClockBoldIcon';
export { CloudArrowUpIcon } from './CloudArrowUpIcon';
export { CloudArrowUpBoldIcon } from './CloudArrowUpBoldIcon';
export { CloudCheckIcon } from './CloudCheckIcon';
export { CloudCheckBoldIcon } from './CloudCheckBoldIcon';
export { CloudSlashIcon } from './CloudSlashIcon';
export { CloudSlashBoldIcon } from './CloudSlashBoldIcon';
export { CloudWarningIcon } from './CloudWarningIcon';
export { CloudWarningBoldIcon } from './CloudWarningBoldIcon';
export { CloudXIcon } from './CloudXIcon';
export { CloudXBoldIcon } from './CloudXBoldIcon';
export { CoffeeIcon } from './CoffeeIcon';
export { CoffeeBoldIcon } from './CoffeeBoldIcon';
export { CoinIcon } from './CoinIcon';
export { CoinBoldIcon } from './CoinBoldIcon';
export { CoinsIcon } from './CoinsIcon';
export { CoinsBoldIcon } from './CoinsBoldIcon';
export { CoinVerticalIcon } from './CoinVerticalIcon';
export { CoinVerticalBoldIcon } from './CoinVerticalBoldIcon';
export { CompassIcon } from './CompassIcon';
export { CompassBoldIcon } from './CompassBoldIcon';
export { CompassFillIcon } from './CompassFillIcon';
export { ConfettiIcon } from './ConfettiIcon';
export { ConfettiBoldIcon } from './ConfettiBoldIcon';
export { ContactlessPaymentIcon } from './ContactlessPaymentIcon';
export { ContactlessPaymentBoldIcon } from './ContactlessPaymentBoldIcon';
export { CornersOutIcon } from './CornersOutIcon';
export { CornersOutBoldIcon } from './CornersOutBoldIcon';
export { CreditCardIcon } from './CreditCardIcon';
export { CreditCardBoldIcon } from './CreditCardBoldIcon';
export { CreditCardFillIcon } from './CreditCardFillIcon';
export { CurrencyBtcIcon } from './CurrencyBtcIcon';
export { CurrencyBtcBoldIcon } from './CurrencyBtcBoldIcon';
export { CurrencyCircleDollarIcon } from './CurrencyCircleDollarIcon';
export { CurrencyCircleDollarBoldIcon } from './CurrencyCircleDollarBoldIcon';
export { CurrencyDollarIcon } from './CurrencyDollarIcon';
export { CurrencyDollarBoldIcon } from './CurrencyDollarBoldIcon';
export { CurrencyDollarSimpleIcon } from './CurrencyDollarSimpleIcon';
export { CurrencyDollarSimpleBoldIcon } from './CurrencyDollarSimpleBoldIcon';
export { CurrencyEthIcon } from './CurrencyEthIcon';
export { CurrencyEthBoldIcon } from './CurrencyEthBoldIcon';
export { CurrencyEurIcon } from './CurrencyEurIcon';
export { CurrencyEurBoldIcon } from './CurrencyEurBoldIcon';
export { CurrencyGbpIcon } from './CurrencyGbpIcon';
export { CurrencyGbpBoldIcon } from './CurrencyGbpBoldIcon';
export { CurrencyJpyIcon } from './CurrencyJpyIcon';
export { CurrencyJpyBoldIcon } from './CurrencyJpyBoldIcon';
export { DeviceMobileIcon } from './DeviceMobileIcon';
export { DeviceMobileBoldIcon } from './DeviceMobileBoldIcon';
export { DevicesIcon } from './DevicesIcon';
export { DevicesBoldIcon } from './DevicesBoldIcon';
export { DiamondIcon } from './DiamondIcon';
export { DiamondBoldIcon } from './DiamondBoldIcon';
export { DoorIcon } from './DoorIcon';
export { DoorBoldIcon } from './DoorBoldIcon';
export { DoorOpenIcon } from './DoorOpenIcon';
export { DoorOpenBoldIcon } from './DoorOpenBoldIcon';
export { DotIcon } from './DotIcon';
export { DotBoldIcon } from './DotBoldIcon';
export { DotsThreeCircleIcon } from './DotsThreeCircleIcon';
export { DotsThreeCircleBoldIcon } from './DotsThreeCircleBoldIcon';
export { DotsThreeCircleVerticalIcon } from './DotsThreeCircleVerticalIcon';
export { DotsThreeCircleVerticalBoldIcon } from './DotsThreeCircleVerticalBoldIcon';
export { DownloadSimpleIcon } from './DownloadSimpleIcon';
export { DownloadSimpleBoldIcon } from './DownloadSimpleBoldIcon';
export { EggIcon } from './EggIcon';
export { EggBoldIcon } from './EggBoldIcon';
export { EnvelopeIcon } from './EnvelopeIcon';
export { EnvelopeBoldIcon } from './EnvelopeBoldIcon';
export { ExportIcon } from './ExportIcon';
export { ExportBoldIcon } from './ExportBoldIcon';
export { EyeIcon } from './EyeIcon';
export { EyeBoldIcon } from './EyeBoldIcon';
export { EyeClosedIcon } from './EyeClosedIcon';
export { EyeClosedBoldIcon } from './EyeClosedBoldIcon';
export { EyeglassesIcon } from './EyeglassesIcon';
export { EyeglassesBoldIcon } from './EyeglassesBoldIcon';
export { EyeSlashIcon } from './EyeSlashIcon';
export { EyeSlashBoldIcon } from './EyeSlashBoldIcon';
export { FacebookLogoIcon } from './FacebookLogoIcon';
export { FacebookLogoBoldIcon } from './FacebookLogoBoldIcon';
export { FactoryIcon } from './FactoryIcon';
export { FactoryBoldIcon } from './FactoryBoldIcon';
export { FileLockIcon } from './FileLockIcon';
export { FileLockBoldIcon } from './FileLockBoldIcon';
export { FilePdfIcon } from './FilePdfIcon';
export { FilePdfBoldIcon } from './FilePdfBoldIcon';
export { FilesIcon } from './FilesIcon';
export { FilesBoldIcon } from './FilesBoldIcon';
export { FileTextIcon } from './FileTextIcon';
export { FileTextBoldIcon } from './FileTextBoldIcon';
export { FingerprintIcon } from './FingerprintIcon';
export { FingerprintBoldIcon } from './FingerprintBoldIcon';
export { FirstAidIcon } from './FirstAidIcon';
export { FirstAidBoldIcon } from './FirstAidBoldIcon';
export { FlagIcon } from './FlagIcon';
export { FlagBoldIcon } from './FlagBoldIcon';
export { FlaskIcon } from './FlaskIcon';
export { FlaskBoldIcon } from './FlaskBoldIcon';
export { GameControllerIcon } from './GameControllerIcon';
export { GameControllerBoldIcon } from './GameControllerBoldIcon';
export { GearIcon } from './GearIcon';
export { GearBoldIcon } from './GearBoldIcon';
export { GiftIcon } from './GiftIcon';
export { GiftBoldIcon } from './GiftBoldIcon';
export { GlobeIcon } from './GlobeIcon';
export { GlobeBoldIcon } from './GlobeBoldIcon';
export { GlobeHemisphereEastIcon } from './GlobeHemisphereEastIcon';
export { GlobeHemisphereEastBoldIcon } from './GlobeHemisphereEastBoldIcon';
export { GlobeHemisphereWestIcon } from './GlobeHemisphereWestIcon';
export { GlobeHemisphereWestBoldIcon } from './GlobeHemisphereWestBoldIcon';
export { GoogleChromeLogoIcon } from './GoogleChromeLogoIcon';
export { GoogleChromeLogoBoldIcon } from './GoogleChromeLogoBoldIcon';
export { GooglePlayLogoIcon } from './GooglePlayLogoIcon';
export { GooglePlayLogoBoldIcon } from './GooglePlayLogoBoldIcon';
export { GraduationCapIcon } from './GraduationCapIcon';
export { GraduationCapBoldIcon } from './GraduationCapBoldIcon';
export { HandIcon } from './HandIcon';
export { HandbagIcon } from './HandbagIcon';
export { HandbagBoldIcon } from './HandbagBoldIcon';
export { HandBoldIcon } from './HandBoldIcon';
export { HandCoinsIcon } from './HandCoinsIcon';
export { HandCoinsBoldIcon } from './HandCoinsBoldIcon';
export { HandPointingIcon } from './HandPointingIcon';
export { HandPointingBoldIcon } from './HandPointingBoldIcon';
export { HandsClappingIcon } from './HandsClappingIcon';
export { HandsClappingBoldIcon } from './HandsClappingBoldIcon';
export { HandsPrayingIcon } from './HandsPrayingIcon';
export { HandsPrayingBoldIcon } from './HandsPrayingBoldIcon';
export { HandWavingIcon } from './HandWavingIcon';
export { HandWavingBoldIcon } from './HandWavingBoldIcon';
export { HeartIcon } from './HeartIcon';
export { HeartBoldIcon } from './HeartBoldIcon';
export { HourglassIcon } from './HourglassIcon';
export { HourglassBoldIcon } from './HourglassBoldIcon';
export { HouseIcon } from './HouseIcon';
export { HouseBoldIcon } from './HouseBoldIcon';
export { HouseFillIcon } from './HouseFillIcon';
export { HouseLineIcon } from './HouseLineIcon';
export { HouseLineBoldIcon } from './HouseLineBoldIcon';
export { IdentificationCardIcon } from './IdentificationCardIcon';
export { IdentificationCardBoldIcon } from './IdentificationCardBoldIcon';
export { ImageIcon } from './ImageIcon';
export { ImageBoldIcon } from './ImageBoldIcon';
export { ImagesIcon } from './ImagesIcon';
export { ImagesBoldIcon } from './ImagesBoldIcon';
export { InfoIcon } from './InfoIcon';
export { InfoBoldIcon } from './InfoBoldIcon';
export { InstagramLogoIcon } from './InstagramLogoIcon';
export { InstagramLogoBoldIcon } from './InstagramLogoBoldIcon';
export { KeyIcon } from './KeyIcon';
export { KeyBoldIcon } from './KeyBoldIcon';
export { LightbulbIcon } from './LightbulbIcon';
export { LightbulbBoldIcon } from './LightbulbBoldIcon';
export { LightningIcon } from './LightningIcon';
export { LightningBoldIcon } from './LightningBoldIcon';
export { LightningSlashIcon } from './LightningSlashIcon';
export { LightningSlashBoldIcon } from './LightningSlashBoldIcon';
export { LinkIcon } from './LinkIcon';
export { LinkBoldIcon } from './LinkBoldIcon';
export { LinkedinLogoIcon } from './LinkedinLogoIcon';
export { LinkedinLogoBoldIcon } from './LinkedinLogoBoldIcon';
export { ListBulletsIcon } from './ListBulletsIcon';
export { ListBulletsBoldIcon } from './ListBulletsBoldIcon';
export { ListChecksIcon } from './ListChecksIcon';
export { ListChecksBoldIcon } from './ListChecksBoldIcon';
export { LockIcon } from './LockIcon';
export { LockBoldIcon } from './LockBoldIcon';
export { LockOpenIcon } from './LockOpenIcon';
export { LockOpenBoldIcon } from './LockOpenBoldIcon';
export { MagnifyingGlassIcon } from './MagnifyingGlassIcon';
export { MagnifyingGlassBoldIcon } from './MagnifyingGlassBoldIcon';
export { MapPinIcon } from './MapPinIcon';
export { MapPinBoldIcon } from './MapPinBoldIcon';
export { MapTrifoldIcon } from './MapTrifoldIcon';
export { MapTrifoldBoldIcon } from './MapTrifoldBoldIcon';
export { MessengerLogoIcon } from './MessengerLogoIcon';
export { MessengerLogoBoldIcon } from './MessengerLogoBoldIcon';
export { MoneyIcon } from './MoneyIcon';
export { MoneyBoldIcon } from './MoneyBoldIcon';
export { NotePencilIcon } from './NotePencilIcon';
export { NotePencilBoldIcon } from './NotePencilBoldIcon';
export { NotificationIcon } from './NotificationIcon';
export { NotificationBoldIcon } from './NotificationBoldIcon';
export { NumberCircleEightIcon } from './NumberCircleEightIcon';
export { NumberCircleEightBoldIcon } from './NumberCircleEightBoldIcon';
export { NumberCircleFiveIcon } from './NumberCircleFiveIcon';
export { NumberCircleFiveBoldIcon } from './NumberCircleFiveBoldIcon';
export { NumberCircleFourIcon } from './NumberCircleFourIcon';
export { NumberCircleFourBoldIcon } from './NumberCircleFourBoldIcon';
export { NumberCircleNineIcon } from './NumberCircleNineIcon';
export { NumberCircleNineBoldIcon } from './NumberCircleNineBoldIcon';
export { NumberCircleOneIcon } from './NumberCircleOneIcon';
export { NumberCircleOneBoldIcon } from './NumberCircleOneBoldIcon';
export { NumberCircleSevenIcon } from './NumberCircleSevenIcon';
export { NumberCircleSevenBoldIcon } from './NumberCircleSevenBoldIcon';
export { NumberCircleSixIcon } from './NumberCircleSixIcon';
export { NumberCircleSixBoldIcon } from './NumberCircleSixBoldIcon';
export { NumberCircleThreeIcon } from './NumberCircleThreeIcon';
export { NumberCircleThreeBoldIcon } from './NumberCircleThreeBoldIcon';
export { NumberCircleTwoIcon } from './NumberCircleTwoIcon';
export { NumberCircleTwoBoldIcon } from './NumberCircleTwoBoldIcon';
export { NumberCircleZeroIcon } from './NumberCircleZeroIcon';
export { NumberCircleZeroBoldIcon } from './NumberCircleZeroBoldIcon';
export { PaperclipIcon } from './PaperclipIcon';
export { PaperclipBoldIcon } from './PaperclipBoldIcon';
export { ParkIcon } from './ParkIcon';
export { ParkBoldIcon } from './ParkBoldIcon';
export { PasswordIcon } from './PasswordIcon';
export { PasswordBoldIcon } from './PasswordBoldIcon';
export { PawPrintIcon } from './PawPrintIcon';
export { PawPrintBoldIcon } from './PawPrintBoldIcon';
export { PaypalLogoIcon } from './PaypalLogoIcon';
export { PaypalLogoBoldIcon } from './PaypalLogoBoldIcon';
export { PencilIcon } from './PencilIcon';
export { PencilBoldIcon } from './PencilBoldIcon';
export { PencilSlashIcon } from './PencilSlashIcon';
export { PencilSlashBoldIcon } from './PencilSlashBoldIcon';
export { PercentIcon } from './PercentIcon';
export { PercentBoldIcon } from './PercentBoldIcon';
export { PhoneIcon } from './PhoneIcon';
export { PhoneBoldIcon } from './PhoneBoldIcon';
export { PhoneCallIcon } from './PhoneCallIcon';
export { PhoneCallBoldIcon } from './PhoneCallBoldIcon';
export { PhoneIncomingIcon } from './PhoneIncomingIcon';
export { PhoneIncomingBoldIcon } from './PhoneIncomingBoldIcon';
export { PiggyBankIcon } from './PiggyBankIcon';
export { PiggyBankBoldIcon } from './PiggyBankBoldIcon';
export { PillIcon } from './PillIcon';
export { PillBoldIcon } from './PillBoldIcon';
export { PlayIcon } from './PlayIcon';
export { PlayBoldIcon } from './PlayBoldIcon';
export { PlayCircleIcon } from './PlayCircleIcon';
export { PlayCircleBoldIcon } from './PlayCircleBoldIcon';
export { PlusIcon } from './PlusIcon';
export { PlusBoldIcon } from './PlusBoldIcon';
export { PlusCircleIcon } from './PlusCircleIcon';
export { PlusCircleBoldIcon } from './PlusCircleBoldIcon';
export { PrinterIcon } from './PrinterIcon';
export { PrinterBoldIcon } from './PrinterBoldIcon';
export { QuestionIcon } from './QuestionIcon';
export { QuestionBoldIcon } from './QuestionBoldIcon';
export { ReceiptIcon } from './ReceiptIcon';
export { ReceiptBoldIcon } from './ReceiptBoldIcon';
export { ReceiptXIcon } from './ReceiptXIcon';
export { ReceiptXBoldIcon } from './ReceiptXBoldIcon';
export { RedditLogoIcon } from './RedditLogoIcon';
export { RedditLogoBoldIcon } from './RedditLogoBoldIcon';
export { RoadHorizonIcon } from './RoadHorizonIcon';
export { RoadHorizonBoldIcon } from './RoadHorizonBoldIcon';
export { RocketIcon } from './RocketIcon';
export { RocketBoldIcon } from './RocketBoldIcon';
export { SealCheckIcon } from './SealCheckIcon';
export { SealCheckBoldIcon } from './SealCheckBoldIcon';
export { ShareIcon } from './ShareIcon';
export { ShareBoldIcon } from './ShareBoldIcon';
export { ShieldCheckIcon } from './ShieldCheckIcon';
export { ShieldCheckBoldIcon } from './ShieldCheckBoldIcon';
export { ShoppingCartIcon } from './ShoppingCartIcon';
export { ShoppingCartBoldIcon } from './ShoppingCartBoldIcon';
export { SignatureIcon } from './SignatureIcon';
export { SignatureBoldIcon } from './SignatureBoldIcon';
export { SlidersIcon } from './SlidersIcon';
export { SlidersBoldIcon } from './SlidersBoldIcon';
export { SlidersHorizontalIcon } from './SlidersHorizontalIcon';
export { SlidersHorizontalBoldIcon } from './SlidersHorizontalBoldIcon';
export { SortAscendingIcon } from './SortAscendingIcon';
export { SortAscendingBoldIcon } from './SortAscendingBoldIcon';
export { SortDescendingIcon } from './SortDescendingIcon';
export { SortDescendingBoldIcon } from './SortDescendingBoldIcon';
export { SpeakerHighIcon } from './SpeakerHighIcon';
export { SpeakerHighBoldIcon } from './SpeakerHighBoldIcon';
export { SpeakerSimpleSlashBoldIcon } from './SpeakerSimpleSlashBoldIcon';
export { SpeakerSlashIcon } from './SpeakerSlashIcon';
export { StarIcon } from './StarIcon';
export { StarBoldIcon } from './StarBoldIcon';
export { StrategyIcon } from './StrategyIcon';
export { StudentIcon } from './StudentIcon';
export { StudentBoldIcon } from './StudentBoldIcon';
export { SuitcaseRollingIcon } from './SuitcaseRollingIcon';
export { SuitcaseRollingBoldIcon } from './SuitcaseRollingBoldIcon';
export { SunIcon } from './SunIcon';
export { SunBoldIcon } from './SunBoldIcon';
export { TagIcon } from './TagIcon';
export { TagBoldIcon } from './TagBoldIcon';
export { TagChevronIcon } from './TagChevronIcon';
export { TagChevronBoldIcon } from './TagChevronBoldIcon';
export { TagSimpleIcon } from './TagSimpleIcon';
export { TagSimpleBoldIcon } from './TagSimpleBoldIcon';
export { TextTIcon } from './TextTIcon';
export { TextTBoldIcon } from './TextTBoldIcon';
export { TicketIcon } from './TicketIcon';
export { TicketBoldIcon } from './TicketBoldIcon';
export { ToggleLeftIcon } from './ToggleLeftIcon';
export { ToggleLeftBoldIcon } from './ToggleLeftBoldIcon';
export { ToggleRightIcon } from './ToggleRightIcon';
export { ToggleRightBoldIcon } from './ToggleRightBoldIcon';
export { ToolboxIcon } from './ToolboxIcon';
export { ToolboxBoldIcon } from './ToolboxBoldIcon';
export { TrademarkIcon } from './TrademarkIcon';
export { TrademarkBoldIcon } from './TrademarkBoldIcon';
export { TrademarkRegisteredIcon } from './TrademarkRegisteredIcon';
export { TrademarkRegisteredBoldIcon } from './TrademarkRegisteredBoldIcon';
export { TrainIcon } from './TrainIcon';
export { TrainBoldIcon } from './TrainBoldIcon';
export { TrashIcon } from './TrashIcon';
export { TrashBoldIcon } from './TrashBoldIcon';
export { TreePalmIcon } from './TreePalmIcon';
export { TreePalmBoldIcon } from './TreePalmBoldIcon';
export { TrendDownIcon } from './TrendDownIcon';
export { TrendDownBoldIcon } from './TrendDownBoldIcon';
export { TrendUpIcon } from './TrendUpIcon';
export { TrendUpBoldIcon } from './TrendUpBoldIcon';
export { TrophyIcon } from './TrophyIcon';
export { TrophyBoldIcon } from './TrophyBoldIcon';
export { TwitterLogoIcon } from './TwitterLogoIcon';
export { TwitterLogoBoldIcon } from './TwitterLogoBoldIcon';
export { UmbrellaIcon } from './UmbrellaIcon';
export { UmbrellaBoldIcon } from './UmbrellaBoldIcon';
export { UserIcon } from './UserIcon';
export { UserBoldIcon } from './UserBoldIcon';
export { UserCircleIcon } from './UserCircleIcon';
export { UserCircleBoldIcon } from './UserCircleBoldIcon';
export { UserCircleGearIcon } from './UserCircleGearIcon';
export { UserCircleGearBoldIcon } from './UserCircleGearBoldIcon';
export { UserFocusIcon } from './UserFocusIcon';
export { UserFocusBoldIcon } from './UserFocusBoldIcon';
export { UserRectangleIcon } from './UserRectangleIcon';
export { UserRectangleBoldIcon } from './UserRectangleBoldIcon';
export { UserSquareIcon } from './UserSquareIcon';
export { UserSquareBoldIcon } from './UserSquareBoldIcon';
export { VideoIcon } from './VideoIcon';
export { VideoBoldIcon } from './VideoBoldIcon';
export { WalletIcon } from './WalletIcon';
export { WalletBoldIcon } from './WalletBoldIcon';
export { WarningIcon } from './WarningIcon';
export { WarningBoldIcon } from './WarningBoldIcon';
export { WarningCircleIcon } from './WarningCircleIcon';
export { WarningCircleBoldIcon } from './WarningCircleBoldIcon';
export { WarningCircleFilledIcon } from './WarningCircleFilledIcon';
export { WarningCircleBoldFilledIcon } from './WarningCircleBoldFilledIcon';
export { WhatsappLogoIcon } from './WhatsappLogoIcon';
export { WhatsappLogoBoldIcon } from './WhatsappLogoBoldIcon';
export { WifiHighIcon } from './WifiHighIcon';
export { WifiHighBoldIcon } from './WifiHighBoldIcon';
export { WifiSlashIcon } from './WifiSlashIcon';
export { WifiSlashBoldIcon } from './WifiSlashBoldIcon';
export { XIcon } from './XIcon';
export { XBoldIcon } from './XBoldIcon';
export { XCircleIcon } from './XCircleIcon';
export { XCircleBoldIcon } from './XCircleBoldIcon';
export { YoutubeLogoIcon } from './YoutubeLogoIcon';
export { YoutubeLogoBoldIcon } from './YoutubeLogoBoldIcon';
export { ThumbsUpBoldIcon } from './ThumbsUpBoldIcon';
export { ThumbsUpIcon } from './ThumbsUpIcon';
export { TargetIcon } from './TargetIcon';
export { TargetBoldIcon } from './TargetBoldIcon';
export { SendIcon } from './SendIcon';
export { SendFilledIcon } from './SendFilledIcon';
export { RetireTreeBoldIcon } from './RetireTreeBoldIcon';
export { RetireTreeIcon } from './RetireTreeIcon';
export { SmartRocketBoldIcon } from './SmartRocketBoldIcon';
export { SmartRocketIcon } from './SmartRocketIcon';
export { TrendUpSoftBoldIcon } from './TrendUpSoftBoldIcon';
export { TrendUpSoftIcon } from './TrendUpSoftIcon';
export { ChatCircleDotsBoldIcon } from './ChatCircleDotsBoldIcon';
export { ChatCircleDotsIcon } from './ChatCircleDotsIcon';
export { LightningDashedCircleBoldIcon } from './LightningDashedCircleBoldIcon';
export { LightningDashedCircleIcon } from './LightningDashedCircleIcon';
export { SparkleIcon } from './SparkleIcon';
export { SparkleBoldIcon } from './SparkleBoldIcon';
export { ArrowUpRightIcon } from './ArrowUpRightIcon';
export { ArrowUpRightBoldIcon } from './ArrowUpRightBoldIcon';
export { ArrowDownRightIcon } from './ArrowDownRightIcon';
export { ArrowDownRightBoldIcon } from './ArrowDownRightBoldIcon';
export { MicrophoneIcon } from './MicrophoneIcon';
export { VoiceRecordIcon } from './VoiceRecordIcon';
export { VoiceRecordBoldIcon } from './VoiceRecordBoldIcon';
export { QuotationIcon } from './QuotationIcon';
export { ChatIcon } from './ChatIcon';
export { ChatBoldIcon } from './ChatBoldIcon';
